import { useState, useEffect, useRef } from "react";

// ─── LOGOS ─────────────────────────────────────────────────────────
const LOGO_PRINCIPAL = "data:image/png;base64,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";
const LOGO_ISOTIPO = "data:image/png;base64,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";

// ─── CONFIG ────────────────────────────────────────────────────────
const SHEET_URL = ""; // ← URL del Apps Script

// NIVELES: 1=Admin, 2=Supervisor, 3=Empleado
const NIVEL1 = ["israel.romero"];
const NIVEL2 = ["rocio.avila","alvaro.valdespino","leonardo.moreno","julio.ramirez"];

const getNivel = (user) => {
  if (NIVEL1.includes(user)) return 1;
  if (NIVEL2.includes(user)) return 2;
  return 3;
};

// ─── USUARIOS INICIALES ────────────────────────────────────────────
const INITIAL_USERS = [
  { id:1,  user:"julio.ramirez",      pass:"93810", name:"JULIO RAMIREZ HERNANDEZ",              dept:"Administración", puesto:"Gerente de Finanzas",  telefono:"", nacimiento:"", ingreso:"2015-04-27", activo:true  },
  { id:2,  user:"cristian.hernandez", pass:"24592", name:"CRISTIAN HERNANDEZ GARCIA",             dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2024-12-03", activo:true  },
  { id:3,  user:"angel.rodriguez",    pass:"13278", name:"ANGEL ISAEL RODRIGUEZ RODRIGUEZ",       dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2024-08-26", activo:true  },
  { id:4,  user:"cuauhtemoc.montes",  pass:"46048", name:"CUAUHTEMOC MONTES MARTINEZ",            dept:"Operaciones", puesto:"Supervisor de Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2023-06-19", activo:true  },
  { id:5,  user:"abel.vazquez",       pass:"42098", name:"ABEL GAMALIEL VAZQUEZ GARCIA",          dept:"Operaciones", puesto:"Supervisor de Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2022-08-15", activo:true  },
  { id:6,  user:"israel.juarez",      pass:"39256", name:"ISRAEL JUAREZ LUGO",                    dept:"Jurídico", puesto:"Coordinador Jurídico",  telefono:"", nacimiento:"", ingreso:"2024-05-02", activo:true  },
  { id:7,  user:"luis.valdespino",    pass:"28289", name:"LUIS ANTONIO VALDESPINO REYES",         dept:"Ingeniería", puesto:"Ingeniero de Proyectos",  telefono:"", nacimiento:"", ingreso:"2023-09-16", activo:true  },
  { id:8,  user:"israel.romero",      pass:"23434", name:"ISRAEL ROMERO RODRIGUEZ",               dept:"Administración", puesto:"Analista de Calidad y Sistemas", telefono:"", nacimiento:"", ingreso:"2023-08-30", activo:true },
  { id:9,  user:"juan.cano",          pass:"98696", name:"JUAN CARLOS CANO HERNANDEZ",            dept:"Operaciones", puesto:"Supervisor de Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2018-04-23", activo:true  },
  { id:10, user:"cesar.chavez",       pass:"81482", name:"CESAR ISRAEL CHAVEZ GUTIERREZ",         dept:"Operaciones", puesto:"Coordinador de Operaciones",  telefono:"", nacimiento:"", ingreso:"2019-02-11", activo:true  },
  { id:11, user:"pedro.lopez",        pass:"21395", name:"PEDRO ANTONIO LOPEZ AGUILAR",           dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2015-04-29", activo:true  },
  { id:12, user:"ana.avila",          pass:"87397", name:"ANA DEL CARMEN AVILA RAMIREZ",          dept:"Administración", puesto:"Coordinadora de Marketing",  telefono:"", nacimiento:"", ingreso:"2025-01-06", activo:true  },
  { id:13, user:"ibeth.rodriguez",    pass:"65302", name:"IBETH RODRIGUEZ CRUZ",                  dept:"Administración", puesto:"Analista de Cotizaciones y Presupuestos",  telefono:"", nacimiento:"", ingreso:"2025-04-21", activo:true  },
  { id:14, user:"jose.felipe",        pass:"14165", name:"JOSE FELIPE FELIPE",                    dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2025-04-16", activo:true  },
  { id:15, user:"leonardo.moreno",    pass:"13905", name:"LEONARDO MORENO CASTANEDA",             dept:"RH", puesto:"Coordinador de Recursos Humanos", telefono:"", nacimiento:"", ingreso:"2025-09-03", activo:true },
  { id:16, user:"flavio.servin",      pass:"22280", name:"FLAVIO CESAR SERVIN TAMAYO",            dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:17, user:"eduardo.ramirez",    pass:"38657", name:"EDUARDO RAMIREZ HERNANDEZ",             dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:18, user:"kevin.gomez",        pass:"40495", name:"KEVIN GOMEZ CASTILLO",                  dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:19, user:"gustavo.gomez",      pass:"76237", name:"GUSTAVO EDDU GOMEZ FALCON",             dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:20, user:"sueriel.bustos",     pass:"88907", name:"SUERIEL BUSTOS BUSTOS",                 dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:21, user:"celso.valdespin",    pass:"13478", name:"CELSO ALEJANDRO VALDESPIN REYES",       dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:22, user:"rocio.avila",        pass:"83563", name:"ROCIO DEL CARMEN AVILA RAMIREZ",        dept:"Administración", puesto:"Gerente de Operaciones", telefono:"", nacimiento:"", ingreso:"2022-03-16", activo:true },
  { id:23, user:"sergio.alvarado",    pass:"36062", name:"SERGIO JESUS ALVARADO MENDOZA",         dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2025-03-18", activo:true  },
  { id:24, user:"jose.gudino",        pass:"95181", name:"JOSE ANTONIO GUDINO RESENDIZ",          dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2025-03-18", activo:true  },
  { id:25, user:"javier.ceron",       pass:"81426", name:"JAVIER CERON ALFARO",                   dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2025-03-18", activo:true  },
  { id:26, user:"fernando.hernandez", pass:"64987", name:"FERNANDO MANUEL HERNANDEZ HERNANDEZ",   dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2025-05-05", activo:true  },
  { id:27, user:"jose.bautista",      pass:"38893", name:"JOSE LUIS BAUTISTA AURELIANO",          dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"2025-05-05", activo:true  },
  { id:28, user:"mariana.gutierrez",  pass:"68878", name:"MARIANA GUTIERREZ RANGEL",              dept:"Administración", puesto:"Auxiliar Administrativo",  telefono:"", nacimiento:"", ingreso:"2025-05-07", activo:true  },
  { id:29, user:"fred.torres",        pass:"87236", name:"FRED ANTONIO TORRES MORALES",           dept:"Operaciones", puesto:"Coordinador de Obra Civil",  telefono:"", nacimiento:"", ingreso:"2025-06-10", activo:true  },
  { id:30, user:"israel.hernandez",   pass:"46463", name:"ISRAEL EFREN HERNANDEZ RODRIGUEZ",      dept:"Ventas", puesto:"Gerente de Ventas",  telefono:"", nacimiento:"", ingreso:"2025-07-14", activo:true  },
  { id:31, user:"juan.valdespino",    pass:"10851", name:"JUAN CARLOS VALDESPINO ROBLES",         dept:"Operaciones", puesto:"Supervisor de Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:32, user:"alison.gonzalez",    pass:"30926", name:"ALISON MICHELLE GONZALEZ ARROYO",       dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:33, user:"otoniel.hernandez",  pass:"65392", name:"OTONIEL HERNANDEZ JIMENEZ",             dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:34, user:"diego.mariano",      pass:"54597", name:"DIEGO MARIANO REYES",                   dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:35, user:"dorian.alonso",      pass:"46421", name:"DORIAN ABEL ALONSO AGUSTIN",            dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:36, user:"jesban.romero",      pass:"30379", name:"JESBAN ROMERO ANGELES",                 dept:"Operaciones", puesto:"Técnico en Mantenimiento",  telefono:"", nacimiento:"", ingreso:"", activo:true  },
  { id:38, user:"maricarmen.fraile",  pass:"62950", name:"MARICARMEN FRAILE CRUZ",          dept:"Administración", puesto:"Coordinadora de Gestión",   telefono:"", nacimiento:"", ingreso:"2025-02-17", activo:true },
  { id:39, user:"elsy.rodriguez",     pass:"59906", name:"ELSY DANAE RODRIGUEZ HERNANDEZ",  dept:"Diseño",         puesto:"Auxiliar de Diseño Gráfico", telefono:"", nacimiento:"", ingreso:"", activo:true },
  { id:37, user:"alvaro.valdespino",  pass:"55291", name:"ALVARO VALDESPINO",                     dept:"Dirección", puesto:"CEO", telefono:"", nacimiento:"", ingreso:"", activo:true },
];

const PROYECTOS_DEFAULT=["AIRBUS","BIOVIRTUAL PIA","BRP","GUARDIAN GLASS","INGREDION","KELLOGG'S","KERRY","SIMA BV","ZF EL MARQUES","ZF SANTA ROSA"];
const TEAM_LIDERES = ["","Álvaro Valdespino","Ana del Carmen","César Chávez","Israel Hernández","Julio Ramírez","Rocío Ávila"];
const CLIENTES     = ["","AIRBUS","BIOAIRE","BIOVIRTUAL","BRP","CENTRO ONCOLOGICO IRAPUATO","CENTRO ONCOLOGICO PACHUCA","CENTRO ONCOLOGICO QRO","COMPARTEC","ECARSUQ","EGO","GNS","GRC AUTOPARTES","GUARDIAN","GUARDIAN GLASS MEXICO","INGREDION","ITACA","KATAYAMA","KELLOGG'S","KERRY","PURATOS","SIMA BV","UNILEVER","ZF DIRECCIONES P1","ZF DIRECCIONES P2","ZF DIRECCIONES P3","ZF EL MARQUES P1","ZF EL MARQUES P2","ZF PIA","ZF SANTA ROSA PLANTA 1","ZF SANTA ROSA PLANTA 2","ZF SANTA ROSA PLANTA 3","ZF SANTA ROSA PLANTA 4","ZF TOLUCA","Otro"];
const AREAS_COMPRAS= ["Rocío Ávila"];
const INCIDENT_TYPES=["Día festivo","Domingo","Tiempo extra","Tiempo por tiempo"];
const VEHICULOS=["","FRONTIER 2025","MARCH EXCLUSIVE 2023","MARCH EXCLUSIVE 2024","MARCH ADVANCE 2025 (OPS)","MARCH ADVANCE 2025 (VENTAS)","NP 300","SAVEIRO/ROBUST"];
const EMPRESAS_INC_DEFAULT=["ADMINISTRACIÓN","AIRBUS","BIOAIRE","BIOVIRTUAL","BRP","CENTRO ONCOLOGICO IRAPUATO","CENTRO ONCOLOGICO PACHUCA","CENTRO ONCOLOGICO QRO","COMPARTEC","ECARSUQ","EGO","GNS","GRC AUTOPARTES","GUARDIAN GLASS MEXICO","INGREDION","ITACA","KATAYAMA","KELLOGG'S","KERRY","PURATOS","SIMA BV","UNILEVER","ZF DIRECCIONES P1","ZF DIRECCIONES P2","ZF DIRECCIONES P3","ZF EL MARQUES P1","ZF EL MARQUES P2","ZF PIA","ZF SANTA ROSA PLANTA 1","ZF SANTA ROSA PLANTA 2","ZF SANTA ROSA PLANTA 3","ZF SANTA ROSA PLANTA 4","ZF TOLUCA"];
const EMPRESAS_SOLIC=["SIMA BV","Biovirtual"];
const UNIDADES     = ["Piezas","Metro","Costal","Cubeta","Caja","Paquete","Galón","Litro","Servicio","Kg","Equipo","Rollo","Juego","M2","Tonelada"];
const DEPTOS       = ["Operaciones","Administración","Mantenimiento","Calidad","Almacén","Compras"];

// ─── UTILS ────────────────────────────────────────────────────────
const TZ = "America/Mexico_City";
const fmt    = d => d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit",second:"2-digit",hour12:false,timeZone:TZ});
const fmtD   = d => d.toLocaleDateString("es-MX",{weekday:"long",year:"numeric",month:"long",day:"numeric",timeZone:TZ});
const fmtISO = d => {
  const loc = new Date(d.toLocaleString("en-US",{timeZone:TZ}));
  const pad = n=>String(n).padStart(2,"0");
  return `${pad(loc.getDate())}/${pad(loc.getMonth()+1)}/${loc.getFullYear()} ${pad(loc.getHours())}:${pad(loc.getMinutes())}:${pad(loc.getSeconds())}`;
};

// Parsea cualquier formato de timestamp guardado
const parseTS = (ts) => {
  if(!ts) return null;
  try{
    // nuevo formato: "06/03/2026 14:23:05"
    const m=ts.match(/(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}:\d{2}:\d{2})/);
    if(m) return new Date(`${m[3]}-${m[2]}-${m[1]}T${m[4]}`);
    // formato legacy ISO: "2026-03-06 14:23:05"
    const m2=ts.match(/(\d{4}-\d{2}-\d{2})\s+(\d{1,2}:\d{2}:\d{2})/);
    if(m2) return new Date(`${m2[1]}T${m2[2]}`);
    return null;
  }catch{ return null; }
};
// Extrae HH:MM:SS de un timestamp guardado usando parseTS
const tsHora = (ts,short=false) => {
  const d=parseTS(ts); if(!d||isNaN(d)) return "---";
  const loc=new Date(d.toLocaleString("en-US",{timeZone:TZ}));
  const pad=n=>String(n).padStart(2,"0");
  return short
    ? `${pad(loc.getHours())}:${pad(loc.getMinutes())}`
    : `${pad(loc.getHours())}:${pad(loc.getMinutes())}:${pad(loc.getSeconds())}`;
};
// Extrae DD/MM/YYYY de un timestamp guardado
const tsFecha = (ts) => {
  const d=parseTS(ts); if(!d||isNaN(d)) return ts?.slice(0,10)||"";
  const loc=new Date(d.toLocaleString("en-US",{timeZone:TZ}));
  const pad=n=>String(n).padStart(2,"0");
  return `${pad(loc.getDate())}/${pad(loc.getMonth()+1)}/${loc.getFullYear()}`;
};
// Key YYYY-MM-DD para agrupar por día
const tsFechaKey = (ts) => {
  const d=parseTS(ts); if(!d||isNaN(d)) return ts?.slice(0,10)||"";
  const loc=new Date(d.toLocaleString("en-US",{timeZone:TZ}));
  const pad=n=>String(n).padStart(2,"0");
  return `${loc.getFullYear()}-${pad(loc.getMonth()+1)}-${pad(loc.getDate())}`;
};
const scColor = s => s==="Entrada"?"#00b4c8":s==="Salida"?"#ff6b6b":"#ffd166";
const nivelLabel = n => n===1?"👑 Admin":n===2?"🔷 Supervisor":"👤 Empleado";
const nivelColor = n => n===1?"#ffd166":n===2?"#74b9ff":"#00b4c8";

let GLOBAL_LOG = [];
let folioCounter = 1200 + Math.floor(Math.random()*100);

async function getIP(){ try{ const r=await fetch("https://api.ipify.org?format=json"); return (await r.json()).ip; }catch{ return "---"; } }
async function sendToSheet(p){ if(!SHEET_URL) return; try{ await fetch(SHEET_URL,{method:"POST",body:JSON.stringify(p)}); }catch(_){} }
function calcHoras(a,b){ if(!a||!b) return "---"; const d=(new Date(b)-new Date(a))/3600000; if(d<0) return "---"; return `${Math.floor(d)}h ${String(Math.round((d-Math.floor(d))*60)).padStart(2,"0")}m`; }
function genId(){ return Date.now()+Math.floor(Math.random()*1000); }

// ─── jsPDF ────────────────────────────────────────────────────────
function loadJsPDF(){ return new Promise(res=>{ if(window.jspdf){res(window.jspdf.jsPDF);return;} const s1=document.createElement("script"); s1.src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"; s1.onload=()=>{ const s2=document.createElement("script"); s2.src="https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.28/jspdf.plugin.autotable.min.js"; s2.onload=()=>res(window.jspdf.jsPDF); document.head.appendChild(s2); }; document.head.appendChild(s1); if(window.jspdf) res(window.jspdf.jsPDF); }); }

async function generarPDF(req){
  const JsPDF=await loadJsPDF(); const doc=new JsPDF({orientation:"portrait",unit:"mm",format:"letter"}); const W=215.9,mg=14;
  doc.setFont("helvetica","bold"); doc.setFontSize(18); doc.setTextColor(0,120,180); doc.text("biovirtual",mg,18);
  doc.setFontSize(7); doc.setTextColor(80,80,80); doc.text("Servicios Integrales de Mantenimiento",mg,23);
  doc.setDrawColor(0,120,180); doc.setLineWidth(0.5); doc.line(mg,26,80,26);
  doc.setFont("helvetica","bold"); doc.setFontSize(13); doc.setTextColor(30,30,30); doc.text("REQUISICIÓN DE COMPRAS O SERVICIOS",W/2+10,14,{align:"center"});
  doc.setDrawColor(0,0,0); doc.setLineWidth(0.3); doc.rect(W/2+5,17,72,14);
  doc.setFontSize(7.5); doc.text("FECHA DE EMISIÓN/HORA",W/2+41,22,{align:"center"});
  doc.setFont("helvetica","normal"); doc.setFontSize(9); doc.text(req.fechaHora,W/2+41,28,{align:"center"});
  let y=32; doc.setFont("helvetica","bold"); doc.setFontSize(8.5); doc.setTextColor(30,30,30);
  doc.text("BIOVIRTUAL S.A DE C.V.",mg,y); doc.text("SERVICIOS INTEGRALES DE MANTENIMIENTO",mg,y+5);
  y=42;
  doc.autoTable({startY:y,head:[["SOLICITANTE","ÁREA/DEPARTAMENTO",""]],body:[[req.solicitante,req.area,`No. DE FOLIO:  ${req.folio}`]],styles:{fontSize:8,cellPadding:2},headStyles:{fillColor:[50,50,50],textColor:255,fontStyle:"bold",fontSize:7.5},columnStyles:{0:{cellWidth:65},1:{cellWidth:80},2:{cellWidth:50}},margin:{left:mg,right:mg},theme:"grid"});
  y=doc.lastAutoTable.finalY+4;
  const rows=req.items.filter(i=>i.nombre).map((it,idx)=>[idx+1,it.nombre,it.unidad,it.cantidad,it.descripcion,""]);
  if(!rows.length) rows.push(["(sin artículos)","","","","",""]);
  doc.autoTable({startY:y,head:[["PARTIDA","NOMBRE","UNIDAD\nMEDIDA","CANTIDAD","DESCRIPCIÓN DE LOS ARTÍCULOS","ESTADO"]],body:rows,styles:{fontSize:8,cellPadding:2},headStyles:{fillColor:[50,50,50],textColor:255,fontStyle:"bold",fontSize:7},columnStyles:{0:{cellWidth:16,halign:"center"},1:{cellWidth:42},2:{cellWidth:20,halign:"center"},3:{cellWidth:20,halign:"center"},4:{cellWidth:70},5:{cellWidth:18,halign:"center"}},margin:{left:mg,right:mg},theme:"grid"});
  y=doc.lastAutoTable.finalY+4;
  doc.autoTable({startY:y,head:[["FECHA RECEPCIÓN EN ÁREA DE COMPRAS","FECHA EN QUE SE REQUIERE"]],body:[[req.fechaHora,req.fechaRequerida||""]],styles:{fontSize:8,cellPadding:2},headStyles:{fillColor:[50,50,50],textColor:255,fontStyle:"bold",fontSize:7},columnStyles:{0:{cellWidth:103},1:{cellWidth:82}},margin:{left:mg,right:mg},theme:"grid"});
  y=doc.lastAutoTable.finalY;
  doc.autoTable({startY:y,head:[["NOMBRE DEL JEFE INMEDIATO","NOMBRE DE ÁREA DE COMPRAS"]],body:[[req.jefeInmediato,req.areaCompras||""]],styles:{fontSize:8,cellPadding:3},headStyles:{fillColor:[50,50,50],textColor:255,fontStyle:"bold",fontSize:7},columnStyles:{0:{cellWidth:103},1:{cellWidth:82}},margin:{left:mg,right:mg},theme:"grid"});
  y=doc.lastAutoTable.finalY+4;
  doc.setFont("helvetica","bold"); doc.setFontSize(8.5); doc.text("Descripción general",mg,y+4);
  doc.setDrawColor(0,0,0); doc.rect(mg,y+6,W-mg*2,12);
  doc.setFont("helvetica","normal"); doc.setFontSize(8.5); doc.text(req.descripcion||"",mg+2,y+12,{maxWidth:W-mg*2-4});
  y+=22;
  doc.autoTable({startY:y,body:[["Estado de\nAdministracion","","Estado de\nAdministracion",""],["Estado de General","","",""]],styles:{fontSize:8,cellPadding:3},columnStyles:{0:{cellWidth:52,fontStyle:"bold"},1:{cellWidth:52},2:{cellWidth:52,fontStyle:"bold"},3:{cellWidth:31}},margin:{left:mg,right:mg},theme:"grid"});
  y=doc.lastAutoTable.finalY+5;
  doc.setFont("helvetica","bolditalic"); doc.setFontSize(7.5); doc.setTextColor(50,50,50);
  doc.text("Nota: este formato se compone de 2 partidas distribuidas de la siguiente manera",mg,y);
  doc.setFont("helvetica","normal"); doc.text("ORIGINAL: Se queda en el área de compras para comprobación",mg,y+4);
  doc.text("COPIA: Es entregada al departamento solicitante para archivo.",mg,y+8);
  doc.save(`Requisicion_${req.folio}_${req.solicitante.replace(/ /g,"_")}.pdf`);
}

// ─── MAPA MODAL ───────────────────────────────────────────────────
function MapaModal({entrada,salida,onClose}){
  const rE=useRef(null),rS=useRef(null),init=useRef(false);
  useEffect(()=>{
    if(init.current) return; init.current=true;
    const lnk=document.createElement("link"); lnk.rel="stylesheet"; lnk.href="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css"; document.head.appendChild(lnk);
    const s=document.createElement("script"); s.src="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js"; s.onload=build; document.head.appendChild(s);
    if(window.L) build();
  },[]);
  const build=()=>setTimeout(()=>{
    const tile="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
    if(rE.current&&entrada?.lat&&entrada.lat!=="---"&&window.L){ const m=window.L.map(rE.current).setView([+entrada.lat,+entrada.lng],15); window.L.tileLayer(tile,{attribution:"© OSM"}).addTo(m); window.L.marker([+entrada.lat,+entrada.lng]).addTo(m).bindPopup(`<b>ENTRADA</b><br>${entrada.ts}`).openPopup(); }
    if(rS.current&&salida?.lat&&salida.lat!=="---"&&window.L){ const m=window.L.map(rS.current).setView([+salida.lat,+salida.lng],15); window.L.tileLayer(tile,{attribution:"© OSM"}).addTo(m); window.L.marker([+salida.lat,+salida.lng]).addTo(m).bindPopup(`<b>SALIDA</b><br>${salida.ts}`).openPopup(); }
  },300);
  return(
    <div style={MS.ov} onClick={onClose}>
      <div style={MS.box} onClick={e=>e.stopPropagation()}>
        <button onClick={onClose} style={MS.x}>✕</button>
        <div style={MS.ttl}>📍 {entrada?.nombre||salida?.nombre}</div>
        <div style={MS.sub}>{entrada?.proyecto} · {entrada?.actividad}</div>
        <div style={MS.grid}>
          {[["ENTRADA","#00b4c8",entrada,rE],["SALIDA","#ff6b6b",salida,rS]].map(([lb,cl,rec,rf])=>(
            <div key={lb} style={MS.card}>
              <div style={{...MS.ch,background:cl}}><div style={MS.ct}>{lb}</div><div style={MS.cm}>Fecha y hora: {rec?.ts||"Pendiente"}</div><div style={MS.cm}>IP: {rec?.ip||"---"}</div></div>
              {rec?.lat&&rec.lat!=="---"?(<><div style={MS.cr}><span style={MS.cL}>Latitud</span><span style={MS.cV}>{rec.lat}</span></div><div style={MS.cr}><span style={MS.cL}>Longitud</span><span style={MS.cV}>{rec.lng}</span></div><div ref={rf} style={MS.map}/></>):<div style={MS.empty}>{lb==="SALIDA"?"Sin datos de salida":"Sin coordenadas"}</div>}
            </div>
          ))}
        </div>
        <div style={MS.hb}><span style={MS.hl}>⏱ Horas trabajadas</span><span style={MS.hv}>{calcHoras(entrada?.ts,salida?.ts)}</span></div>
      </div>
    </div>
  );
}
const MS={ov:{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:12},box:{background:"#f5f8fc",borderRadius:18,padding:22,width:"100%",maxWidth:860,maxHeight:"94vh",overflowY:"auto",position:"relative"},x:{position:"absolute",top:14,right:14,background:"#e8eef6",border:"none",color:"#6a8aaa",borderRadius:8,width:28,height:28,cursor:"pointer",fontSize:13,fontWeight:700},ttl:{fontSize:17,fontWeight:800,color:"#fff",marginBottom:4},sub:{fontSize:12,color:"#777",marginBottom:18},grid:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14},card:{background:"#f0f6fb",borderRadius:12,overflow:"hidden"},ch:{padding:"14px 16px"},ct:{fontSize:17,fontWeight:900,color:"#ffffff",letterSpacing:1},cm:{fontSize:12,color:"#ffffff",opacity:0.8,marginTop:3},cr:{display:"flex",justifyContent:"space-between",padding:"8px 14px",borderBottom:"1px solid #2e333d"},cL:{fontSize:12,color:"#7a9ab0"},cV:{fontSize:12,color:"#1a2a3a",fontFamily:"monospace"},map:{height:210,width:"100%"},empty:{padding:40,textAlign:"center",color:"#8aabbc",fontSize:13},hb:{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#f0f6fb",borderRadius:12,padding:"14px 20px",marginTop:16},hl:{fontSize:14,color:"#6a8aaa"},hv:{fontSize:24,fontWeight:900,color:"#00b4c8"}};

// ─── GESTIÓN USUARIOS (nivel 1) ───────────────────────────────────
function GestionUsuarios({users, setUsers, showToast, catalogos}){
  const [vista,setVista]=useState("lista");
  const [editU,setEditU]=useState(null);
  const [search,setSearch]=useState("");
  const [form,setForm]=useState({user:"",pass:"",name:"",dept:"Operaciones",puesto:"",telefono:"",nacimiento:"",ingreso:"",foto:"",activo:true});
  const setF=(k,v)=>setForm(p=>({...p,[k]:v}));

  const calcEdad=(nac)=>{
    if(!nac) return null;
    const hoy=new Date(), d=new Date(nac+"T12:00:00");
    let age=hoy.getFullYear()-d.getFullYear();
    if(hoy.getMonth()<d.getMonth()||(hoy.getMonth()===d.getMonth()&&hoy.getDate()<d.getDate())) age--;
    return age;
  };

  const handleFoto=(e)=>{
    const file=e.target.files[0]; if(!file) return;
    if(file.size>10*1024*1024){showToast("La imagen no debe superar 10 MB","err");return;}
    const reader=new FileReader();
    reader.onload=(ev)=>setF("foto",ev.target.result);
    reader.readAsDataURL(file);
  };

  const openEdit=(u)=>{ setEditU(u); setForm({...u,ingreso:u.ingreso||"",foto:u.foto||"",credenciales:u.credenciales||[]}); setVista("editar"); };
  const openNuevo=()=>{ setForm({user:"",pass:"",name:"",dept:"Operaciones",puesto:"",telefono:"",nacimiento:"",ingreso:"",foto:"",activo:true,credenciales:[]}); setVista("nuevo"); };

  const guardar=()=>{
    if(!form.user||!form.pass||!form.name){showToast("Usuario, contraseña y nombre son obligatorios","err");return;}
    const cleanCreds=(form.credenciales||[]).filter(c=>c.empresa&&c.fechaVenc).map(c=>({...c,editable:false}));
    const saveForm={...form,credenciales:cleanCreds};
    if(vista==="nuevo"){
      if(users.find(u=>u.user===form.user)){showToast("Ese usuario ya existe","err");return;}
      setUsers(p=>[...p,{...saveForm,id:genId()}]);
      showToast("Usuario creado ✓");
    } else {
      setUsers(p=>p.map(u=>u.id===editU.id?{...saveForm,id:u.id}:u));
      showToast("Usuario actualizado ✓");
    }
    setVista("lista");
  };

  const toggleActivo=(u)=>{ setUsers(p=>p.map(x=>x.id===u.id?{...x,activo:!x.activo}:x)); showToast(`Usuario ${u.activo?"desactivado":"activado"} ✓`); };
  const filtered=users.filter(u=>!search||u.name.toLowerCase().includes(search.toLowerCase())||u.user.toLowerCase().includes(search.toLowerCase())).slice().sort((a,b)=>a.name.localeCompare(b.name));
  const edad=calcEdad(form.nacimiento);

  if(vista!=="lista") return(
    <div style={S.card}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
        <button onClick={()=>setVista("lista")} style={{background:"none",border:"none",color:"#7a9ab0",cursor:"pointer",fontSize:20}}>←</button>
        <h2 style={{...S.cardTitle,margin:0}}>{vista==="nuevo"?"➕ Nuevo Usuario":"✏️ Editar Usuario"}</h2>
      </div>

      {/* Foto */}
      <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:4}}>
        <div style={{width:72,height:72,borderRadius:"50%",background:"#f0f6fb",border:"2px solid #2e333d",overflow:"hidden",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
          {form.foto
            ? <img src={form.foto} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>
            : <span style={{fontSize:28,color:"#8aabbc"}}>👤</span>}
        </div>
        <div>
          <label style={{...S.label,marginBottom:4}}>Fotografía (máx. 10 MB)</label>
          <input type="file" accept="image/*" onChange={handleFoto} style={{fontSize:12,color:"#7a9ab0"}}/>
          {form.foto&&<button onClick={()=>setF("foto","")} style={{marginTop:4,background:"none",border:"none",color:"#ff6b6b",cursor:"pointer",fontSize:11}}>✕ Quitar foto</button>}
        </div>
      </div>

      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 180px"}}><label style={S.label}>Nombre completo</label><input style={S.input} value={form.name} onChange={e=>setF("name",e.target.value)} placeholder="NOMBRE APELLIDO1 APELLIDO2"/></div>
        <div style={{flex:"1 1 130px"}}><label style={S.label}>Usuario</label><input style={S.input} value={form.user} onChange={e=>setF("user",e.target.value.toLowerCase().replace(/ /g,""))} placeholder="nombre.apellido"/></div>
        <div style={{flex:"1 1 100px"}}><label style={S.label}>Contraseña</label><input style={S.input} value={form.pass} onChange={e=>setF("pass",e.target.value)}/></div>
      </div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 130px"}}><label style={S.label}>Departamento</label><select style={S.select} value={form.dept} onChange={e=>setF("dept",e.target.value)}>{DEPTOS.map(d=><option key={d}>{d}</option>)}</select></div>
        <div style={{flex:"1 1 130px"}}><label style={S.label}>Puesto</label><input style={S.input} value={form.puesto} onChange={e=>setF("puesto",e.target.value)} placeholder="Ej: Técnico"/></div>
      </div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 130px"}}><label style={S.label}>Teléfono</label><input style={S.input} type="tel" value={form.telefono} onChange={e=>setF("telefono",e.target.value)} placeholder="442 000 0000"/></div>
        <div style={{flex:"1 1 130px"}}>
          <label style={S.label}>Fecha de nacimiento {edad!==null&&<span style={{color:"#00b4c8",fontWeight:700,marginLeft:6}}>{edad} años</span>}</label>
          <input style={S.input} type="date" value={form.nacimiento} onChange={e=>setF("nacimiento",e.target.value)}/>
        </div>
        <div style={{flex:"1 1 130px"}}><label style={S.label}>Fecha de ingreso</label><input style={S.input} type="date" value={form.ingreso} onChange={e=>setF("ingreso",e.target.value)}/></div>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <label style={S.label}>Estado</label>
        <button onClick={()=>setF("activo",!form.activo)} style={{background:form.activo?"#00e5a020":"#ff6b6b20",border:`1px solid ${form.activo?"#00b4c8":"#ff6b6b"}`,borderRadius:8,padding:"6px 14px",color:form.activo?"#00b4c8":"#ff6b6b",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>{form.activo?"✅ Activo":"🚫 Inactivo"}</button>
      </div>

      {/* ── Credenciales Vigentes ── */}
      <div style={{borderTop:"1px solid #ddeaf4",paddingTop:12}}>
        <label style={{...S.label,fontSize:14,marginBottom:8}}>📜 Credenciales Vigentes</label>
        <div style={{maxHeight:360,overflowY:"auto"}}>
          {(form.credenciales||[]).map((c,i)=>{
            const vig=credVigenciaColor(c.fechaVenc);
            return(
              <div key={i} style={{background:"#f5f8fc",borderRadius:10,padding:"10px 12px",marginBottom:8,border:"1px solid #e2eaf4"}}>
                <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                  <div style={{flex:"1 1 130px"}}><label style={{fontSize:10,color:"#7a9ab0"}}>Empresa</label>
                    {c.editable?<select style={{...S.select,padding:"6px 8px",fontSize:12,marginBottom:0}} value={c.empresa||""} onChange={e=>{const nc=[...(form.credenciales||[])];nc[i]={...nc[i],empresa:e.target.value};setF("credenciales",nc);}}>
                      <option value="">-- Seleccione --</option>
                      {(catalogos?.empresas||EMPRESAS_INC_DEFAULT).map(emp=><option key={emp} value={emp}>{emp}</option>)}
                    </select>:<div style={{fontSize:12,fontWeight:600,color:"#1D3A57"}}>{c.empresa||"---"}</div>}
                  </div>
                  <div style={{flex:"1 1 110px"}}><label style={{fontSize:10,color:"#7a9ab0"}}>Vencimiento</label>
                    {c.editable?<input style={{...S.input,padding:"6px 8px",fontSize:12,marginBottom:0}} type="date" value={c.fechaVenc} onChange={e=>{const nc=[...(form.credenciales||[])];nc[i]={...nc[i],fechaVenc:e.target.value};setF("credenciales",nc);}}/>
                    :<div style={{fontSize:12,fontWeight:600,color:"#1D3A57"}}>{c.fechaVenc||"---"}</div>}
                  </div>
                  <div style={{flex:"0 0 80px",textAlign:"center"}}><label style={{fontSize:10,color:"#7a9ab0"}}>Vigente</label><div style={{fontSize:11,fontWeight:800,color:vig.color,background:vig.color+"18",borderRadius:6,padding:"3px 8px"}}>{vig.label}</div></div>
                  {c.editable&&<button onClick={()=>{const nc=(form.credenciales||[]).filter((_,j)=>j!==i);setF("credenciales",nc);}} style={{background:"none",border:"none",color:"#ff6b6b",cursor:"pointer",fontSize:16,padding:"2px 6px",flexShrink:0}} title="Eliminar">✕</button>}
                </div>
              </div>
            );
          })}
        </div>
        {(form.credenciales||[]).length===0&&<p style={{color:"#8aabbc",fontSize:12,textAlign:"center",margin:"8px 0"}}>Sin credenciales registradas</p>}
        <div style={{display:"flex",gap:8,marginTop:8}}>
          <button onClick={()=>{
            const nc=[...(form.credenciales||[]),{empresa:"",fechaVenc:"",editable:true}];
            setF("credenciales",nc);
          }} style={{flex:1,background:"#1D3A57",border:"none",borderRadius:10,padding:"10px 0",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>+ Agregar Curso</button>
          <button onClick={()=>{
            const nc=(form.credenciales||[]).map(c=>({...c,editable:true}));
            setF("credenciales",nc);showToast("Credenciales desbloqueadas para edición");
          }} style={{flex:1,background:"#ffc107",border:"none",borderRadius:10,padding:"10px 0",color:"#1D3A57",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>✏️ Actualizar Curso</button>
        </div>
      </div>

      <button onClick={guardar} style={{...S.checkBtn,background:"#1D3A57",color:"#ffffff",fontSize:15}}>💾 Guardar</button>
    </div>
  );

  return(
    <div style={S.card}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <h2 style={{...S.cardTitle,margin:0}}>👥 Usuarios y Proyectos</h2>
        <div style={{display:"flex",gap:6}}>
          <button onClick={()=>{
            const hdr=["NOMBRE","USUARIO","CONTRASEÑA","DEPARTAMENTO","PUESTO","TELÉFONO","NACIMIENTO","INGRESO","ACTIVO","CREDENCIALES"];
            const rows=users.map(u=>[u.name,u.user,u.pass,u.dept,u.puesto,u.telefono||"",u.nacimiento||"",u.ingreso||"",u.activo!==false?"SI":"NO",(u.credenciales||[]).map(c=>c.empresa+":"+c.fechaVenc).join("; ")]);
            const csv=[hdr,...rows].map(r=>r.map(c=>'"'+String(c??"").replace(/"/g,'""')+'"').join(",")).join("\n");
            const blob=new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8"});
            const url=URL.createObjectURL(blob);const a=document.createElement("a");a.href=url;a.download="Usuarios_"+new Date().toISOString().slice(0,10)+".csv";a.click();URL.revokeObjectURL(url);
            showToast("CSV descargado ✓");
          }} style={{background:"#1D3A57",border:"none",borderRadius:8,padding:"7px 12px",color:"#ffffff",fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>📥 CSV</button>
          <button onClick={openNuevo} style={{background:"#1D3A57",border:"none",borderRadius:8,padding:"7px 14px",color:"#ffffff",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit"}}>+ Nuevo</button>
        </div>
      </div>
      <input style={S.input} placeholder="🔍 Buscar…" value={search} onChange={e=>setSearch(e.target.value)}/>
      <div style={{fontSize:11,color:"#8aabbc"}}>{filtered.length} usuarios · {filtered.filter(u=>u.activo).length} activos</div>
      {filtered.map(u=>{
        const nv=getNivel(u.user); const ed=calcEdad(u.nacimiento);
        return(
          <div key={u.id} style={{background:"#f0f6fb",borderRadius:10,padding:"12px 14px",marginTop:6,opacity:u.activo?1:0.5}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div style={{display:"flex",gap:10,alignItems:"center"}}>
                <div style={{width:40,height:40,borderRadius:"50%",background:"#f5f8fc",overflow:"hidden",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  {u.foto?<img src={u.foto} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:<span style={{fontSize:18,color:nivelColor(nv)}}>{u.name[0]}</span>}
                </div>
                <div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontWeight:700,fontSize:13,color:"#1D3A57"}}>{u.name}</span>
                    <span style={{fontSize:10,background:nivelColor(nv)+"20",color:nivelColor(nv),borderRadius:4,padding:"2px 6px",fontWeight:700}}>{nivelLabel(nv)}</span>
                    {!u.activo&&<span style={{fontSize:10,background:"#ff6b6b20",color:"#ff6b6b",borderRadius:4,padding:"2px 6px"}}>Inactivo</span>}
                  </div>
                  <div style={{fontSize:11,color:"#7a9ab0",marginTop:2}}>@{u.user} · {u.dept}{u.puesto?` · ${u.puesto}`:""}{ed!==null?` · ${ed} años`:""}</div>
                  {u.ingreso&&<div style={{fontSize:11,color:"#8aaacc"}}>📅 Ingreso: {u.ingreso}</div>}
                </div>
              </div>
              <div style={{display:"flex",gap:6}}>
                <button onClick={()=>openEdit(u)} style={{background:"#e8eef6",border:"none",borderRadius:7,padding:"5px 9px",cursor:"pointer",color:"#6a8aaa",fontSize:13}}>✏️</button>
                <button onClick={()=>toggleActivo(u)} style={{background:"#e8eef6",border:"none",borderRadius:7,padding:"5px 9px",cursor:"pointer",color:u.activo?"#ff6b6b":"#00b4c8",fontSize:13}}>{u.activo?"🚫":"✅"}</button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ─── FORMULARIO REQUISICIÓN ───────────────────────────────────────
function FormRequisicion({session,now,showToast,onSaved,catalogos={}}){
  const emptyItem=()=>({nombre:"",unidad:"Piezas",cantidad:"",descripcion:"",foto:""});
  const [form,setForm]=useState({solicitante:session.name,folio:String(++folioCounter),area:session.dept,fechaRequerida:"",proyecto:"",cliente:"",jefeInmediato:"",areaCompras:"Rocío Ávila",descripcion:""});
  const [items,setItems]=useState([emptyItem()]); const [saving,setSaving]=useState(false);
  const setF=(k,v)=>setForm(p=>({...p,[k]:v}));
  const addItem=()=>{ if(items.length>=30){showToast("Máximo 30 artículos","err");return;} setItems(p=>[...p,emptyItem()]); };
  const removeItem=i=>setItems(p=>p.filter((_,x)=>x!==i));
  const setItem=(i,k,v)=>setItems(p=>p.map((it,x)=>x===i?{...it,[k]:v}:it));

  const handleItemFoto=(i,e)=>{
    const file=e.target.files[0]; if(!file) return;
    if(file.size>5*1024*1024){showToast("La imagen no debe superar 5 MB","err");return;}
    const reader=new FileReader();
    reader.onload=(ev)=>setItem(i,"foto",ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleGuardar=async()=>{
    if(!form.proyecto){showToast("Selecciona el proyecto","err");return;}
    if(!form.jefeInmediato){showToast("Selecciona el jefe inmediato","err");return;}
    if(!items.some(i=>i.nombre.trim())){showToast("Agrega al menos un artículo","err");return;}
    setSaving(true);
    const fechaHora=fmtISO(now); const req={...form,fechaHora,items,id:genId()};
    sendToSheet({tipo:"requisicion",fila:[fechaHora,form.folio,form.solicitante,form.area,form.proyecto,form.cliente,form.jefeInmediato,form.areaCompras,items.filter(i=>i.nombre).map((it,x)=>`${x+1}. ${it.nombre}`).join(" | "),form.descripcion]});
    sendToSheet({tipo:"req_listado",fila:[fechaHora,form.folio,form.solicitante,form.area,form.proyecto,form.cliente,form.jefeInmediato,items.filter(i=>i.nombre).length,form.descripcion,"Pendiente"]});
    GLOBAL_LOG=[{tipo:"requisicion",...req,nombre:session.name,email:session.user},...GLOBAL_LOG];
    const pdfBlob=await generarPDF(req);
    onSaved(req);
    showToast("PDF generado ✓","ok"); setSaving(false);
    setItems([emptyItem()]); setForm(p=>({...p,folio:String(++folioCounter),proyecto:"",cliente:"",jefeInmediato:"",areaCompras:"",descripcion:"",fechaRequerida:""}));
  };
  return(
    <div style={S.card}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><h2 style={{...S.cardTitle,margin:0}}>📋 Requisición de Compras</h2><span style={{fontSize:11,color:"#8aabbc",background:"#f0f6fb",borderRadius:6,padding:"3px 8px"}}>Folio {form.folio}</span></div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <div style={{flex:"2 1 160px"}}><label style={S.label}>Solicitante</label><input style={{...S.input,background:"#eef3f9",color:"#7a9ab0"}} value={form.solicitante} readOnly/></div>
        <div style={{flex:"1 1 160px"}}><label style={S.label}>Fecha y Hora</label><input style={{...S.input,background:"#eef3f9",color:"#7a9ab0"}} value={fmtISO(now)} readOnly/></div>
        <div style={{flex:"1 1 120px"}}><label style={S.label}>Departamento</label><input style={{...S.input,background:"#eef3f9",color:"#00b4c8",fontWeight:700}} value={session.dept||"---"} readOnly/></div>
      </div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 140px"}}><label style={S.label}>Para el día:</label><input style={S.input} type="date" value={form.fechaRequerida} onChange={e=>setF("fechaRequerida",e.target.value)}/></div>
        <div style={{flex:"1 1 140px"}}><label style={S.label}>Proyecto <span style={{color:"#ff6b6b"}}>*</span></label>
          <select style={S.select} value={form.proyecto} onChange={e=>setF("proyecto",e.target.value)}>
            <option value="">-- Seleccione --</option>
            {(()=>{const _pr=catalogos?.proyectos||PROYECTOS_DEFAULT.map(n=>({nombre:n,activo:true}));return _pr.filter(p=>typeof p==="string"||p.activo).map(p=>typeof p==="string"?p:p.nombre).sort().map(n=><option key={n} value={n}>{n}</option>);})()}
          </select>
        </div>
        <div style={{flex:"1 1 140px"}}><label style={S.label}>Cliente</label><select style={S.select} value={form.cliente} onChange={e=>setF("cliente",e.target.value)}>{CLIENTES.map(c=><option key={c} value={c}>{c||"-- Seleccione --"}</option>)}</select></div>
      </div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 160px"}}><label style={S.label}>Jefe inmediato</label><select style={S.select} value={form.jefeInmediato} onChange={e=>setF("jefeInmediato",e.target.value)}>{TEAM_LIDERES.map(l=><option key={l} value={l}>{l||"-- Seleccione --"}</option>)}</select></div>
        <div style={{flex:"1 1 160px"}}><label style={S.label}>Área de compras</label><input style={{...S.input,background:"#eef3f9",color:"#00b4c8",fontWeight:700}} value="Rocío Ávila" readOnly/></div>
      </div>
      <div style={{borderTop:"1px solid #ddeaf4",paddingTop:12}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <span style={{fontSize:12,color:"#7a9ab0",fontWeight:600}}>ARTÍCULOS ({items.length}/30)</span>
          <button onClick={addItem} style={{background:"#1D3A57",border:"none",borderRadius:8,padding:"5px 12px",color:"#ffffff",fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>+ Agregar</button>
        </div>
        {items.map((it,i)=>(
          <div key={i} style={{background:"#f0f6fb",borderRadius:10,padding:"10px 12px",marginBottom:8,border:"1px solid #d8e8f4"}}>
            <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:6}}>
              <span style={{fontSize:12,color:"#8aabbc",fontWeight:700,flexShrink:0}}>#{i+1}</span>
              <input style={{...RF.cell,flex:3}} placeholder="Artículo…" value={it.nombre} onChange={e=>setItem(i,"nombre",e.target.value)}/>
              <select style={{...RF.cell,width:90,flexShrink:0}} value={it.unidad} onChange={e=>setItem(i,"unidad",e.target.value)}>{UNIDADES.map(u=><option key={u}>{u}</option>)}</select>
              <input style={{...RF.cell,width:66,flexShrink:0}} type="number" min="0" placeholder="0" value={it.cantidad} onChange={e=>setItem(i,"cantidad",e.target.value)}/>
              <button onClick={()=>removeItem(i)} style={{background:"none",border:"none",color:"#ff6b6b",cursor:"pointer",fontSize:14,padding:"0 4px",flexShrink:0}}>✕</button>
            </div>
            <input style={{...RF.cell,width:"100%",marginBottom:6,boxSizing:"border-box"}} placeholder="Descripción…" value={it.descripcion} onChange={e=>setItem(i,"descripcion",e.target.value)}/>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <label style={{fontSize:11,color:"#8aaacc",flexShrink:0}}>📷 Foto (opcional)</label>
              {it.foto
                ? <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <img src={it.foto} style={{width:48,height:48,objectFit:"cover",borderRadius:6,border:"1px solid #d8e8f4"}} alt=""/>
                    <button onClick={()=>setItem(i,"foto","")} style={{background:"none",border:"none",color:"#ff6b6b",cursor:"pointer",fontSize:11}}>✕</button>
                  </div>
                : <input type="file" accept="image/*" onChange={e=>handleItemFoto(i,e)} style={{fontSize:11,color:"#8aaacc"}}/>}
            </div>
          </div>
        ))}
      </div>
      <div><label style={S.label}>Descripción general / Justificación</label><textarea style={{...S.input,height:70,resize:"vertical"}} value={form.descripcion} onChange={e=>setF("descripcion",e.target.value)} placeholder="Justificación de la requisición…"/></div>
      <button onClick={handleGuardar} disabled={saving} style={{...S.checkBtn,background:"#1D3A57",color:"#ffffff",fontSize:15,fontWeight:800}}>{saving?"⏳ Generando PDF…":"📄 Guardar y Generar PDF"}</button>
    </div>
  );
}
const RF={cell:{background:"#ffffff",border:"1px solid #d0dcea",borderRadius:8,padding:"8px 10px",color:"#000000",fontSize:13,outline:"none",fontFamily:"inherit",minWidth:0}};

// ─── HISTORIAL SEMANA ────────────────────────────────────────────
function HistorialSemana({checkLog}){
  const [abiertos,setAbiertos]=useState({});
  const [pagina,setPagina]=useState(1);
  const POR_PAGINA=10;
  const toggle=(k)=>setAbiertos(p=>({...p,[k]:!p[k]}));

  // Emparejar entradas y salidas cronológicamente (cada sesión = 1 par)
  const sorted=[...checkLog].sort((a,b)=>{
    const da=parseTS(a.ts)||0, db=parseTS(b.ts)||0;
    return da-db;
  });
  const pares=[];
  const stack=[];
  sorted.forEach(r=>{
    if(r.checkTipo==="Entrada") stack.push(r);
    else if(r.checkTipo==="Salida"){
      const e=stack.pop();
      pares.push({entrada:e||null,salida:r,id:(e?.id||r.id)+"p"});
    }
  });
  stack.forEach(e=>pares.push({entrada:e,salida:null,id:e.id+"p"}));
  const todosPares=pares.reverse();
  const totalPaginas=Math.max(1,Math.ceil(todosPares.length/POR_PAGINA));
  const paginaActual=todosPares.slice((pagina-1)*POR_PAGINA,pagina*POR_PAGINA);

  const fmtShort=(ts)=>{
    const d=parseTS(ts); if(!d||isNaN(d)) return "---";
    const loc=new Date(d.toLocaleString("en-US",{timeZone:TZ}));
    const dias=["DOM","LUN","MAR","MIÉ","JUE","VIE","SÁB"];
    const pad=n=>String(n).padStart(2,"0");
    return `${dias[loc.getDay()]} ${pad(loc.getDate())}/${pad(loc.getMonth()+1)}/${loc.getFullYear()}`;
  };
  const calcH=(e,s)=>{
    const de=parseTS(e?.ts),ds=parseTS(s?.ts);
    if(!de||!ds||isNaN(de)||isNaN(ds)) return null;
    const m=Math.round(Math.abs((ds-de)/60000));
    const h=Math.floor(m/60),mn=m%60;
    return {largo:`${h} h ${String(mn).padStart(2,"0")} min`,corto:`${h}h ${String(mn).padStart(2,"0")}m`};
  };
  const pgVis=()=>{
    const p=[];
    if(totalPaginas<=7){for(let i=1;i<=totalPaginas;i++)p.push(i);return p;}
    p.push(1);
    if(pagina>3)p.push("...");
    for(let i=Math.max(2,pagina-1);i<=Math.min(totalPaginas-1,pagina+1);i++)p.push(i);
    if(pagina<totalPaginas-2)p.push("...");
    p.push(totalPaginas);
    return p;
  };

  if(todosPares.length===0) return <p style={{color:"#8aabbc",textAlign:"center",margin:"16px 0",fontSize:13}}>Sin registros aún</p>;

  const ini=(pagina-1)*POR_PAGINA+1, fin2=Math.min(pagina*POR_PAGINA,todosPares.length);
  return(
    <div style={{marginTop:4}}>
      <div style={{fontSize:11,color:"#9ab0c0",textAlign:"center",marginBottom:10}}>
        Mostrando {ini}–{fin2} de {todosPares.length} registros
      </div>
      {paginaActual.map(({entrada,salida,id})=>{
        const ab=abiertos[id];
        const h=calcH(entrada,salida);
        const tE=!!entrada,tS=!!salida,ok=tE&&tS;
        const col=ok?"#00b4c8":tE?"#ffd166":"#888";
        const tsRef=entrada?.ts||salida?.ts;
        return(
          <div key={id} style={{background:"#f0f6fb",borderRadius:10,marginBottom:7,overflow:"hidden",border:`1px solid ${col}22`}}>
            <button onClick={()=>toggle(id)} style={{width:"100%",background:"none",border:"none",cursor:"pointer",padding:"11px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",fontFamily:"inherit"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:col,flexShrink:0,boxShadow:`0 0 6px ${col}`}}/>
                <div style={{textAlign:"left"}}>
                  <div style={{fontSize:13,fontWeight:700,color:"#1a2a3a"}}>{fmtShort(tsRef)}</div>
                  <div style={{fontSize:11,color:"#8aaacc",marginTop:1}}>
                    {tE?<span style={{color:"#00b4c8"}}>↑ {tsHora(entrada?.ts,true)}</span>:<span style={{color:"#8aabbc"}}>Sin entrada</span>}
                    {tS&&<span style={{color:"#ff6b6b",marginLeft:8}}>↓ {tsHora(salida?.ts,true)}</span>}
                    {!tS&&tE&&<span style={{color:"#1a3a6e",marginLeft:8,fontSize:10}}>En curso</span>}
                  </div>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                {ok&&<span style={{fontSize:11,color:"#1a3a6e",fontWeight:700}}>{h?.corto||"---"}</span>}
                <span style={{color:"#8aabbc",fontSize:12,display:"inline-block",transform:ab?"rotate(180deg)":"rotate(0deg)",transition:"transform 0.2s"}}>▼</span>
              </div>
            </button>
            {ab&&(
              <div style={{borderTop:"1px solid #2e333d",padding:"12px 14px",display:"flex",flexDirection:"column",gap:10}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  <div style={{background:"#f5f8fc",borderRadius:8,padding:"10px 12px"}}>
                    <div style={{fontSize:10,color:"#8aaacc",fontWeight:700}}>ENTRADA</div>
                    <div style={{fontSize:16,color:"#00b4c8",fontWeight:800,marginTop:3}}>{tsHora(entrada?.ts)||"---"}</div>
                    <div style={{fontSize:10,color:"#8aabbc",marginTop:2}}>{tsFecha(entrada?.ts)}</div>
                  </div>
                  <div style={{background:"#f5f8fc",borderRadius:8,padding:"10px 12px"}}>
                    <div style={{fontSize:10,color:"#8aaacc",fontWeight:700}}>SALIDA</div>
                    <div style={{fontSize:16,color:tS?"#ff6b6b":"#ffd166",fontWeight:800,marginTop:3}}>{salida?.ts?tsHora(salida.ts):"Pendiente"}</div>
                    <div style={{fontSize:10,color:"#8aabbc",marginTop:2}}>{tsFecha(salida?.ts)}</div>
                  </div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  <div><div style={{fontSize:10,color:"#8aaacc"}}>PROYECTO</div><div style={{fontSize:12,color:"#2a4a6a",marginTop:2}}>{entrada?.proyecto||salida?.proyecto||"---"}</div></div>
                  <div><div style={{fontSize:10,color:"#8aaacc"}}>TEAM LÍDER</div><div style={{fontSize:12,color:"#2a4a6a",marginTop:2}}>{entrada?.teamLider||salida?.teamLider||"---"}</div></div>
                </div>
                <div><div style={{fontSize:10,color:"#8aaacc"}}>ACTIVIDAD</div><div style={{fontSize:12,color:"#2a4a6a",marginTop:2,fontStyle:"italic"}}>{entrada?.actividad||salida?.actividad||"---"}</div></div>
                {ok&&(<div style={{background:"#f5f8fc",borderRadius:8,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:12,color:"#7a9ab0"}}>⏱ Horas trabajadas</span>
                  <span style={{fontSize:15,fontWeight:800,color:"#1a3a6e"}}>{h?.largo||"---"}</span>
                </div>)}
              </div>
            )}
          </div>
        );
      })}
      {totalPaginas>1&&(
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:4,marginTop:12,flexWrap:"wrap"}}>
          <button onClick={()=>{setPagina(p=>Math.max(1,p-1));setAbiertos({});}} disabled={pagina===1} style={{...PG.btn,opacity:pagina===1?0.3:1}}>‹ Anterior</button>
          {pgVis().map((p,i)=>p==="..."
            ?<span key={"e"+i} style={{color:"#8aabbc",fontSize:13,padding:"0 4px"}}>…</span>
            :<button key={p} onClick={()=>{setPagina(p);setAbiertos({});}} style={{...PG.btn,...(p===pagina?PG.active:{}),minWidth:36}}>{p}</button>
          )}
          <button onClick={()=>{setPagina(p=>Math.min(totalPaginas,p+1));setAbiertos({});}} disabled={pagina===totalPaginas} style={{...PG.btn,opacity:pagina===totalPaginas?0.3:1}}>Siguiente ›</button>
        </div>
      )}
    </div>
  );
}
const PG={
  btn:{background:"#f0f6fb",border:"1px solid #d8e8f4",borderRadius:8,padding:"7px 12px",color:"#6a8aaa",cursor:"pointer",fontSize:13,fontFamily:"inherit"},
  active:{background:"#00b4c8",color:"#ffffff",fontWeight:800,border:"1px solid #00e5a0"},
};

// ─── FORM INCIDENCIAS ────────────────────────────────────────────
const emptyInc = () => ({
  id:genId(), fecha:"", hEntrada:"", hSalida:"",
  tipo:INCIDENT_TYPES[0], empresa:"", observaciones:""
});

function calcTotalHoras(hE,hS){
  if(!hE||!hS) return {total:null,totalMin:0};
  const [eh,em]=hE.split(":").map(Number);
  const [sh,sm]=hS.split(":").map(Number);
  const eMin=eh*60+em, sMin=sh*60+sm;
  const diff=Math.abs(sMin-eMin);
  return {total:`${Math.floor(diff/60)}h ${String(diff%60).padStart(2,"0")}m`, totalMin:diff};
}
function calcHorasLaborales(fecha){
  if(!fecha) return {label:"---",min:0};
  const d=new Date(fecha+"T12:00:00");
  const dow=d.getDay(); // 0=dom,6=sab
  if(dow===6) return {label:"6h 00m",min:360};
  if(dow===0) return {label:"9h 00m",min:540};
  return {label:"10h 00m",min:600};
}
function calcDiferencia(totalMin,labMin){
  if(!totalMin||!labMin) return "---";
  const diff=totalMin-labMin;
  const abs=Math.abs(diff);
  const h=Math.floor(abs/60),m=abs%60;
  const lbl=`${h}h ${String(m).padStart(2,"0")}m`;
  return diff>=0?`+${lbl} (Extra)`:`-${lbl} (Faltante)`;
}

function FormIncidencias({session,now,showToast,onEnviadas}){
  const [jefe,setJefe]=useState("");
  const [empresaSol,setEmpresaSol]=useState("SIMA BV");
  const [rows,setRows]=useState([emptyInc()]);
  const [enviando,setEnviando]=useState(false);

  const setRow=(i,k,v)=>setRows(p=>p.map((r,x)=>x===i?{...r,[k]:v}:r));
  const addRow=()=>setRows(p=>[...p,emptyInc()]);
  const removeRow=(i)=>{ if(rows.length===1){showToast("Debe haber al menos una incidencia","err");return;} setRows(p=>p.filter((_,x)=>x!==i)); };

  const handleEnviar=async()=>{
    if(!jefe){showToast("Selecciona el jefe inmediato","err");return;}
    for(const r of rows){
      if(!r.fecha){showToast("Completa la fecha en todas las incidencias","err");return;}
      if(!r.tipo){showToast("Selecciona el tipo en todas las incidencias","err");return;}
      if(!r.empresa){showToast("Selecciona desarrollo de actividades en todas las incidencias","err");return;}
      if(!r.observaciones?.trim()){showToast("Completa las observaciones en todas las incidencias","err");return;}
    }
    setEnviando(true);
    const ts=fmtISO(now);
    const batch=rows.map(r=>{
      const {total,totalMin}=calcTotalHoras(r.hEntrada,r.hSalida);
      const lab=calcHorasLaborales(r.fecha);
      const dif=calcDiferencia(totalMin,lab.min);
      return {
        id:r.id, tipo:"incidencia", ts,
        nombre:session.name, puesto:session.puesto,
        empresaSolicitante:empresaSol, jefe,
        fecha:r.fecha, hEntrada:r.hEntrada, hSalida:r.hSalida,
        totalHoras:total||"---", horasLaborales:lab.label,
        diferencia:dif, tipoInc:r.tipo,
        empresa:r.empresa, observaciones:r.observaciones,
        email:session.user
      };
    });
    batch.forEach(b=>{
      sendToSheet({tipo:"incidencia",fila:[b.ts,b.nombre,b.email,b.puesto,b.empresaSolicitante,b.jefe,b.fecha,b.hEntrada,b.hSalida,b.totalHoras,b.horasLaborales,b.diferencia,b.tipoInc,b.empresa,b.observaciones]});
    });
    onEnviadas(batch);
    showToast(`${batch.length} incidencia(s) enviada(s) ✓`);
    setRows([emptyInc()]); setJefe(""); setEnviando(false);
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {/* Header compartido */}
      <div style={S.card}>
        <h2 style={{...S.cardTitle,margin:0}}>📋 Reporte de Incidencias</h2>
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          <div style={{flex:"1 1 140px"}}>
            <label style={S.label}>Nombre del solicitante</label>
            <input style={{...S.input,background:"#eef3f9",color:"#7a9ab0"}} value={session.name} readOnly/>
          </div>
          <div style={{flex:"1 1 120px"}}>
            <label style={S.label}>Cargo</label>
            <input style={{...S.input,background:"#eef3f9",color:"#7a9ab0"}} value={session.puesto||"---"} readOnly/>
          </div>
        </div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          <div style={{flex:"1 1 140px"}}>
            <label style={S.label}>Empresa</label>
            <select style={S.select} value={empresaSol} onChange={e=>setEmpresaSol(e.target.value)}>
              {EMPRESAS_SOLIC.map(e=><option key={e}>{e}</option>)}
            </select>
          </div>
          <div style={{flex:"1 1 140px"}}>
            <label style={S.label}>Jefe inmediato</label>
            <select style={S.select} value={jefe} onChange={e=>setJefe(e.target.value)}>
              {TEAM_LIDERES.map(l=><option key={l} value={l}>{l||"-- Seleccione --"}</option>)}
            </select>
          </div>
        </div>
      </div>

      {/* Filas de incidencias */}
      {rows.map((r,i)=>{
        const {total,totalMin}=calcTotalHoras(r.hEntrada,r.hSalida);
        const lab=calcHorasLaborales(r.fecha);
        const dif=calcDiferencia(totalMin,lab.min);
        const difColor=dif.startsWith("+")||dif==="---"?"#00b4c8":"#ff6b6b";
        return(
          <div key={r.id} style={{...S.card,position:"relative",gap:10}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:12,color:"#8aaacc",fontWeight:700}}>INCIDENCIA {i+1}</span>
              {rows.length>1&&<button onClick={()=>removeRow(i)} style={{background:"none",border:"none",color:"#ff6b6b",cursor:"pointer",fontSize:18,padding:0}}>✕</button>}
            </div>

            {/* Fecha + Desarrollo de Actividades */}
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              <div style={{flex:"1 1 140px"}}><label style={S.label}>Fecha</label>
                <input style={S.input} type="date" value={r.fecha} onChange={e=>setRow(i,"fecha",e.target.value)}/>
                {r.fecha&&<div style={{fontSize:11,color:"#8aaacc",marginTop:3}}>📅 Horas laborales: <span style={{color:"#1a3a6e",fontWeight:700}}>{lab.label}</span></div>}
              </div>
              <div style={{flex:"1 1 140px"}}><label style={S.label}>Desarrollo de Actividades</label>
                <select style={S.select} value={r.empresa} onChange={e=>setRow(i,"empresa",e.target.value)}>
                  {EMPRESAS_INC_DEFAULT.map(e=><option key={e} value={e}>{e||"-- Seleccione --"}</option>)}
                </select>
              </div>
            </div>

            {/* Horas */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              <div><label style={S.label}>H. Entrada</label>
                <input style={S.input} type="time" value={r.hEntrada} onChange={e=>setRow(i,"hEntrada",e.target.value)}/>
              </div>
              <div><label style={S.label}>H. Salida</label>
                <input style={S.input} type="time" value={r.hSalida} onChange={e=>setRow(i,"hSalida",e.target.value)}/>
              </div>
            </div>

            {/* Diferencia */}
            {(r.hEntrada&&r.hSalida&&r.fecha)&&(
              <div style={{background:"#f5f8fc",borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontSize:12,color:"#7a9ab0"}}>Diferencia vs jornada</span>
                <span style={{fontSize:13,fontWeight:800,color:difColor}}>{dif}</span>
              </div>
            )}

            {/* Total horas + Tipo de incidencia */}
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              <div style={{flex:"1 1 130px"}}><label style={S.label}>Total horas</label>
                <input style={{...S.input,background:"#eef3f9",color:total?"#ffd166":"#555",fontWeight:700}} value={total||"---"} readOnly/>
              </div>
              <div style={{flex:"1 1 130px"}}><label style={S.label}>Tipo de incidencia</label>
                <select style={S.select} value={r.tipo} onChange={e=>setRow(i,"tipo",e.target.value)}>
                  {INCIDENT_TYPES.map(t=><option key={t}>{t}</option>)}
                </select>
              </div>
            </div>

            {/* Observaciones */}
            <div><label style={S.label}>Observaciones</label>
              <textarea style={{...S.input,height:64,resize:"vertical"}} value={r.observaciones} onChange={e=>setRow(i,"observaciones",e.target.value)} placeholder="Ingresa observaciones…"/>
            </div>
          </div>
        );
      })}

      {/* Botones */}
      <button onClick={addRow} style={{background:"#1D3A57",border:"none",borderRadius:12,padding:"13px 0",color:"#ffffff",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
        + Cargar nueva incidencia
      </button>
      <button onClick={handleEnviar} disabled={enviando} style={{...S.checkBtn,background:"#1D3A57",color:"#fff",fontSize:15,fontWeight:800}}>
        {enviando?"⏳ Enviando…":"📤 Enviar incidencias"}
      </button>
    </div>
  );
}

function MisIncidencias({incidents,allIncidents,session}){
  const [abiertos,setAbiertos]=useState({});
  const [pagina,setPagina]=useState(1);
  const POR_PAG=10;
  const toggle=(k)=>setAbiertos(p=>({...p,[k]:!p[k]}));
  const rawIncs=allIncidents?allIncidents.filter(i=>i.email===session?.user&&(i.tipo==="incidencia"||i.tipoInc)):incidents.filter(i=>i.tipo==="incidencia"||i.tipoInc);
  const incs=rawIncs;
  const aprobadas=incs.filter(i=>i.aprobada===true).length;
  const canceladas=incs.filter(i=>i.aprobada===false).length;
  const pendientes=incs.filter(i=>i.aprobada===undefined).length;
  const total=incs.length, totPag=Math.max(1,Math.ceil(total/POR_PAG));
  const pagIncs=incs.slice((pagina-1)*POR_PAG,pagina*POR_PAG);
  const pgVis=()=>{const p=[];if(totPag<=7){for(let i=1;i<=totPag;i++)p.push(i);return p;}p.push(1);if(pagina>3)p.push("...");for(let i=Math.max(2,pagina-1);i<=Math.min(totPag-1,pagina+1);i++)p.push(i);if(pagina<totPag-2)p.push("...");p.push(totPag);return p;};
  const ini=(pagina-1)*POR_PAG+1, fin=Math.min(pagina*POR_PAG,total);
  return(
    <div style={S.card}>
      <h2 style={{...S.cardTitle,margin:0,marginBottom:8}}>🗒 Mis Incidencias</h2>
      {/* Resumen de estatus */}
      {total>0&&(
        <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap"}}>
          {aprobadas>0&&<div style={{background:"#00e5a020",border:"1px solid #00e5a040",borderRadius:8,padding:"6px 12px",fontSize:12,color:"#00b4c8",fontWeight:700}}>✅ {aprobadas} aprobada(s)</div>}
          {canceladas>0&&<div style={{background:"#ff6b6b20",border:"1px solid #ff6b6b40",borderRadius:8,padding:"6px 12px",fontSize:12,color:"#ff6b6b",fontWeight:700}}>❌ {canceladas} cancelada(s)</div>}
          {pendientes>0&&<div style={{background:"#ffd16620",border:"1px solid #ffd16640",borderRadius:8,padding:"6px 12px",fontSize:12,color:"#1a3a6e",fontWeight:700}}>⏳ {pendientes} pendiente(s)</div>}
        </div>
      )}
      {total===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"20px 0"}}>Sin incidencias registradas</p>}
      {total>0&&<div style={{fontSize:11,color:"#9ab0c0",textAlign:"center",marginBottom:10}}>Mostrando {ini}–{fin} de {total}</div>}
      {pagIncs.map((inc)=>{
        const ab=abiertos[inc.id];
        const est=inc.aprobada===true?"APROBADA":inc.aprobada===false?"CANCELADA":"PENDIENTE";
        const col=inc.aprobada===true?"#00b4c8":inc.aprobada===false?"#ff6b6b":"#ffd166";
        return(
          <div key={inc.id} style={{background:"#f0f6fb",borderRadius:10,marginBottom:7,overflow:"hidden",border:`1px solid ${col}33`}}>
            <button onClick={()=>toggle(inc.id)} style={{width:"100%",background:"none",border:"none",cursor:"pointer",padding:"11px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",fontFamily:"inherit"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:col,flexShrink:0}}/>
                <div style={{textAlign:"left"}}>
                  <div style={{fontSize:13,fontWeight:700,color:"#1a2a3a"}}>{inc.tipoInc||inc.tipo}</div>
                  <div style={{fontSize:11,color:"#8aaacc",marginTop:1}}>{inc.fecha} · {inc.empresa||"---"}</div>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:10,background:col+"22",color:col,borderRadius:4,padding:"2px 8px",fontWeight:700}}>{est}</span>
                <span style={{color:"#8aabbc",fontSize:12,display:"inline-block",transform:ab?"rotate(180deg)":"rotate(0deg)",transition:"transform 0.2s"}}>▼</span>
              </div>
            </button>
            {ab&&(
              <div style={{borderTop:"1px solid #2e333d",padding:"12px 14px",display:"flex",flexDirection:"column",gap:8}}>
                {[["Empresa sol.",inc.empresaSolicitante],["Jefe inmediato",inc.jefe],["Fecha",inc.fecha],["H. Entrada",inc.hEntrada||"---"],["H. Salida",inc.hSalida||"---"],["Total horas",inc.totalHoras],["Hrs laborales",inc.horasLaborales],["Diferencia",inc.diferencia],["Empresa",inc.empresa||"---"],["Observaciones",inc.observaciones||"---"],["Revisada por",inc.revisadaPor||"---"]].map(([k,v])=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",gap:8}}>
                    <span style={{fontSize:11,color:"#8aaacc",flexShrink:0}}>{k}</span>
                    <span style={{fontSize:12,color:"#2a4a6a",textAlign:"right"}}>{v}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
      {totPag>1&&(
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:4,marginTop:12,flexWrap:"wrap"}}>
          <button onClick={()=>{setPagina(p=>Math.max(1,p-1));setAbiertos({});}} disabled={pagina===1} style={{...PG.btn,opacity:pagina===1?0.3:1}}>‹</button>
          {pgVis().map((p,i)=>p==="..."?<span key={"e"+i} style={{color:"#8aabbc",fontSize:13}}>…</span>:<button key={p} onClick={()=>{setPagina(p);setAbiertos({});}} style={{...PG.btn,...(p===pagina?PG.active:{}),minWidth:34}}>{p}</button>)}
          <button onClick={()=>{setPagina(p=>Math.min(totPag,p+1));setAbiertos({});}} disabled={pagina===totPag} style={{...PG.btn,opacity:pagina===totPag?0.3:1}}>›</button>
        </div>
      )}
    </div>
  );
}

// ─── MIS REQUISICIONES ────────────────────────────────────────────
function MisRequisiciones({requisiciones, showToast}){
  const [abiertos,setAbiertos]=useState({});
  const toggle=k=>setAbiertos(p=>({...p,[k]:!p[k]}));
  const reqs=[...requisiciones].sort((a,b)=>b.fechaHora?.localeCompare(a.fechaHora));
  if(reqs.length===0) return <div style={S.card}><h2 style={S.cardTitle}>📁 Mis Requisiciones</h2><p style={{color:"#8aabbc",textAlign:"center",margin:"20px 0"}}>Sin requisiciones aún</p></div>;
  return(
    <div style={S.card}>
      <h2 style={{...S.cardTitle,margin:0,marginBottom:8}}>📁 Mis Requisiciones</h2>
      <div style={{fontSize:11,color:"#8aabbc",marginBottom:8}}>{reqs.length} requisición(es)</div>
      {reqs.map(r=>{
        const ab=abiertos[r.id];
        return(
          <div key={r.id} style={{background:"#f0f6fb",borderRadius:10,marginBottom:7,overflow:"hidden",border:"1px solid #d8e8f4"}}>
            <button onClick={()=>toggle(r.id)} style={{width:"100%",background:"none",border:"none",cursor:"pointer",padding:"11px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",fontFamily:"inherit"}}>
              <div style={{textAlign:"left"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#1a2a3a"}}>Folio {r.folio} · {r.cliente||"Sin cliente"}</div>
                <div style={{fontSize:11,color:"#8aaacc",marginTop:1}}>{r.fechaHora?.slice(0,10)} · {r.items?.length||0} artículo(s)</div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <button onClick={e=>{e.stopPropagation();generarPDF(r).then(()=>showToast("PDF regenerado ✓"));}} style={{background:"#f5f8fc",border:"1px solid #d8e8f4",borderRadius:6,padding:"4px 8px",color:"#a29bfe",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>📄 PDF</button>
                <span style={{color:"#8aabbc",fontSize:12,display:"inline-block",transform:ab?"rotate(180deg)":"rotate(0deg)",transition:"transform 0.2s"}}>▼</span>
              </div>
            </button>
            {ab&&(
              <div style={{borderTop:"1px solid #2e333d",padding:"12px 14px",display:"flex",flexDirection:"column",gap:6}}>
                {[["Proyecto",r.proyecto],["Cliente",r.cliente],["Área",r.area],["Jefe inmediato",r.jefeInmediato]].map(([k,v])=>v&&(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",gap:8}}>
                    <span style={{fontSize:11,color:"#8aaacc",flexShrink:0}}>{k}</span>
                    <span style={{fontSize:12,color:"#2a4a6a",textAlign:"right"}}>{v}</span>
                  </div>
                ))}
                <div style={{fontSize:11,color:"#8aabbc",marginTop:4}}>📦 {r.items?.filter(i=>i.nombre).length||0} artículo(s) · Ver detalle en el PDF ↑</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}


// ─── PANEL ASISTENCIA MEJORADO ────────────────────────────────────
function PanelAsistencia({allUsers}){
  const [sel,setSel]=useState(null);
  const [filtroUser,setFiltroUser]=useState("");
  const [filtroDesde,setFiltroDesde]=useState("");
  const [filtroHasta,setFiltroHasta]=useState("");

  const registros=GLOBAL_LOG.filter(r=>r.tipo==="checado");

  // Build pairs per user per day
  const map={};
  [...registros].sort((a,b)=>{const da=parseTS(a.ts)||0,db=parseTS(b.ts)||0;return da-db;}).forEach(r=>{
    const k=`${r.email}_${tsFechaKey(r.ts)}`;
    if(r.checkTipo==="Entrada") map[k]={...map[k],entrada:r};
    else map[k]={...map[k],salida:r};
  });
  let pairs=Object.values(map).reverse();

  // Filter by user
  if(filtroUser) pairs=pairs.filter(p=>(p.entrada||p.salida)?.email===filtroUser);
  // Filter by date range
  if(filtroDesde) pairs=pairs.filter(p=>{
    const ts=(p.entrada||p.salida)?.ts; if(!ts) return false;
    return tsFechaKey(ts)>=filtroDesde;
  });
  if(filtroHasta) pairs=pairs.filter(p=>{
    const ts=(p.entrada||p.salida)?.ts; if(!ts) return false;
    return tsFechaKey(ts)<=filtroHasta;
  });

  const calcH=(e,s)=>{const de=parseTS(e?.ts),ds=parseTS(s?.ts);if(!de||!ds||isNaN(de)||isNaN(ds))return null;const m=Math.round(Math.abs((ds-de)/60000));const h=Math.floor(m/60),mn=m%60;return `${h}h ${String(mn).padStart(2,"0")}m`;};

  const descargarCSV=()=>{
    const hdr=["NOMBRE","USUARIO","DEPTO","PUESTO","FECHA","ENTRADA","SALIDA","HORAS","PROYECTO","TEAM LÍDER","ACTIVIDAD","LAT ENTRADA","LNG ENTRADA","IP ENTRADA"];
    const rows=pairs.map(p=>{
      const e=p.entrada,s=p.salida;
      const h=calcH(e,s);
      return [e?.nombre||s?.nombre||"",e?.email||s?.email||"",e?.dept||s?.dept||"",e?.puesto||s?.puesto||"",tsFecha(e?.ts||s?.ts),tsHora(e?.ts),s?.ts?tsHora(s.ts):"Pendiente",h||"---",e?.proyecto||s?.proyecto||"",e?.teamLider||s?.teamLider||"",e?.actividad||s?.actividad||"",e?.lat||"",e?.lng||"",e?.ip||""];
    });
    const csvContent=[hdr,...rows].map(r=>r.map(c=>'"'+String(c??"").replace(/"/g,'""')+'"').join(",")).join("\n");
    const blob=new Blob(["\uFEFF"+csvContent],{type:'text/csv;charset=utf-8'});
    const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download=`Asistencia_${new Date().toISOString().slice(0,10)}.csv`;a.click();URL.revokeObjectURL(url);
  };

  const usersUniq=[...new Set(registros.map(r=>r.email))].sort();

  return(
    <div style={S.card}>
      {sel&&<MapaModal entrada={sel.entrada} salida={sel.salida} onClose={()=>setSel(null)}/>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,gap:8,flexWrap:"wrap"}}>
        <h2 style={{...S.cardTitle,margin:0}}>📊 Panel de Asistencia</h2>
        <button onClick={descargarCSV} style={{background:"#1D3A57",border:"none",borderRadius:8,padding:"7px 13px",color:"#ffffff",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>📥 CSV</button>
      </div>
      {/* Filtros */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 140px"}}>
          <label style={S.label}>Usuario</label>
          <select style={S.select} value={filtroUser} onChange={e=>setFiltroUser(e.target.value)}>
            <option value="">Todos</option>
            {usersUniq.map(u=>{const usr=allUsers.find(x=>x.user===u);return(<option key={u} value={u}>{usr?.name||u}</option>);})}
          </select>
        </div>
        <div style={{flex:"1 1 120px"}}><label style={S.label}>Desde</label><input style={S.input} type="date" value={filtroDesde} onChange={e=>setFiltroDesde(e.target.value)}/></div>
        <div style={{flex:"1 1 120px"}}><label style={S.label}>Hasta</label><input style={S.input} type="date" value={filtroHasta} onChange={e=>setFiltroHasta(e.target.value)}/></div>
      </div>
      <div style={{fontSize:11,color:"#8aabbc"}}>{pairs.length} registros</div>
      {pairs.length===0&&<p style={{color:"#8aabbc",textAlign:"center",marginTop:20}}>Sin registros</p>}
      {pairs.map((p,i)=>{
        const e=p.entrada,s=p.salida,h=calcH(e,s);
        const usr=allUsers.find(x=>x.user===(e||s)?.email);
        return(
          <div key={i} style={{background:"#f0f6fb",borderRadius:10,padding:"12px 14px",marginTop:8}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div style={{display:"flex",gap:10,alignItems:"center"}}>
                <div style={{width:40,height:40,borderRadius:"50%",background:"#f5f8fc",overflow:"hidden",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  {usr?.foto?<img src={usr.foto} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:<span style={{fontSize:18,color:"#00b4c8"}}>{(e||s)?.nombre?.[0]||"?"}</span>}
                </div>
                <div>
                  <div style={{fontWeight:700,fontSize:13,color:"#1D3A57"}}>{(e||s)?.nombre}</div>
                  <div style={{fontSize:11,color:"#7a9ab0"}}>{(e||s)?.dept} · {tsFecha((e||s)?.ts)}</div>
                </div>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{fontSize:13,fontWeight:800,color:h?"#ffd166":"#444"}}>{h||"---"}</span>
                <button onClick={()=>setSel(p)} style={{background:"#f5f8fc",border:"none",borderRadius:7,padding:"5px 9px",cursor:"pointer",fontSize:15}}>📍</button>
              </div>
            </div>
            <div style={{display:"flex",gap:16,marginTop:8,flexWrap:"wrap"}}>
              <div><div style={{fontSize:10,color:"#8aaacc"}}>ENTRADA</div><div style={{fontSize:12,color:"#00b4c8",fontWeight:700}}>{tsHora(e?.ts)||"---"}</div></div>
              <div><div style={{fontSize:10,color:"#8aaacc"}}>SALIDA</div><div style={{fontSize:12,color:"#ff6b6b",fontWeight:700}}>{s?.ts?tsHora(s.ts):"Pendiente"}</div></div>
              <div><div style={{fontSize:10,color:"#8aaacc"}}>PROYECTO</div><div style={{fontSize:12,color:"#2a4a6a"}}>{e?.proyecto||"---"}</div></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ─── INC PERSONAL con filtros de periodo/usuario ──────────────────
function IncPersonal({allIncidents,setAllIncidents,session,showToast,allUsers}){
  const [filtro,setFiltro]=useState("");
  const [filtroUser,setFiltroUser]=useState("");
  const [filtroDesde,setFiltroDesde]=useState("");
  const [filtroHasta,setFiltroHasta]=useState("");
  const [filtroTipo,setFiltroTipo]=useState("");
  const isRH=session?.puesto?.toLowerCase().includes("recursos humanos");
  const isAdmin=session?.nivel<=2;

  const incs=allIncidents.filter(i=>i.tipo==="incidencia"||i.tipoInc);
  let filtered=incs.filter(i=>!filtro||i.nombre?.toLowerCase().includes(filtro.toLowerCase())||i.tipoInc?.toLowerCase().includes(filtro.toLowerCase()));
  if(filtroUser) filtered=filtered.filter(i=>i.email===filtroUser);
  if(filtroDesde) filtered=filtered.filter(i=>i.fecha>=filtroDesde);
  if(filtroHasta) filtered=filtered.filter(i=>i.fecha<=filtroHasta);
  if(filtroTipo) filtered=filtered.filter(i=>(i.tipoInc||i.tipo)===filtroTipo);

  const aprobar=(id,aprobado)=>{ setAllIncidents(p=>p.map(i=>i.id===id?{...i,aprobada:aprobado,revisadaPor:session.name,tsRevision:fmtISO(new Date())}:i)); showToast(aprobado?"✅ Incidencia aprobada":"❌ Incidencia cancelada"); };

  const descargarCSV=()=>{
    const dataRows=filtered.map((i,idx)=>[idx+1,i.nombre||"",i.fecha||"",i.puesto||"",i.hEntrada||"",i.hSalida||"",i.totalHoras||"",i.horasLaborales||"",i.diferencia||"","","",i.tipoInc||i.tipo||"",i.empresa||"",i.observaciones||"",i.aprobada===true?"APROBADA":i.aprobada===false?"CANCELADA":"PENDIENTE"]);
    const hdr1=["","","","BIOVIRTUAL SA DE CV","","","","","","","","","","",""];
    const hdr2=["","","","REGISTRO DE INCIDENCIAS","","","","","","","","","","",""];
    const hdr3=["#","NOMBRE","FECHA","PUESTO","H. ENTRADA","H. SALIDA","TOTAL DE HORAS","HORAS LABORALES","DIFERENCIA DE HORAS","COSTO POR HORA","MONTO","TIPO DE INCIDENCIA","EMPRESA","OBSERVACIONES","ESTATUS"];
    const nombres=[...new Set(filtered.map(i=>i.nombre))].sort();const tipos=[...new Set(filtered.map(i=>i.tipoInc||i.tipo))].sort();
    const pivHdr=["NOMBRE",...tipos,"Suma total"];
    const pivRows=nombres.map(n=>{const row=[n];let tot=0;tipos.forEach(t=>{const m=filtered.filter(i=>i.nombre===n&&(i.tipoInc||i.tipo)===t).reduce((s,i)=>s+(parseFloat(i.monto)||0),0);row.push(m||"");tot+=m;});row.push(tot||"");return row;});
    const totRow=["Suma total",...tipos.map(t=>filtered.filter(i=>(i.tipoInc||i.tipo)===t).reduce((s,i)=>s+(parseFloat(i.monto)||0),0)),""];
    const csvRows=[hdr3,...dataRows].map(r=>r.map(c=>'"'+String(c??"").replace(/"/g,'""')+'"').join(",")).join("\n");
    const blob=new Blob(["\uFEFF"+csvRows],{type:'text/csv;charset=utf-8'});
    const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download=`Incidencias_${new Date().toISOString().slice(0,10)}.csv`;a.click();URL.revokeObjectURL(url);
    showToast("CSV descargado ✓");
  };

  const usersUniq=[...new Set(incs.map(i=>i.email))].sort();

  return(
    <div style={S.card}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,flexWrap:"wrap",gap:8}}>
        <h2 style={{...S.cardTitle,margin:0}}>👔 Incidencias del Personal</h2>
        <button onClick={descargarCSV} style={{background:"#1D3A57",border:"none",borderRadius:8,padding:"7px 13px",color:"#ffffff",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>📥 CSV</button>
      </div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 140px"}}><label style={S.label}>Desde</label><input style={S.input} type="date" value={filtroDesde} onChange={e=>setFiltroDesde(e.target.value)}/></div>
        <div style={{flex:"1 1 140px"}}><label style={S.label}>Hasta</label><input style={S.input} type="date" value={filtroHasta} onChange={e=>setFiltroHasta(e.target.value)}/></div>
      </div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 140px"}}>
          <label style={S.label}>Usuario(s)</label>
          <select style={S.select} value={filtroUser} onChange={e=>setFiltroUser(e.target.value)}>
            <option value="">Todos</option>
            {usersUniq.map(u=>{const usr=allUsers.find(x=>x.user===u);return(<option key={u} value={u}>{usr?.name||u}</option>);})}
          </select>
        </div>
        <div style={{flex:"1 1 140px"}}>
          <label style={S.label}>Tipo de incidencia</label>
          <select style={S.select} value={filtroTipo} onChange={e=>setFiltroTipo(e.target.value)}>
            <option value="">Todos</option>
            {INCIDENT_TYPES.filter(Boolean).map(t=><option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      </div>
      <input style={S.input} placeholder="🔍 Buscar por nombre…" value={filtro} onChange={e=>setFiltro(e.target.value)}/>
      <div style={{fontSize:11,color:"#8aabbc",marginBottom:4}}>{filtered.length} incidencias</div>
      {filtered.length===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"20px 0"}}>Sin incidencias registradas</p>}
      {filtered.map(inc=>{
        const est=inc.aprobada===true?"APROBADA":inc.aprobada===false?"CANCELADA":"PENDIENTE";
        const estCol=inc.aprobada===true?"#00b4c8":inc.aprobada===false?"#ff6b6b":"#ffd166";
        return(
          <div key={inc.id} style={{background:"#f0f6fb",borderRadius:10,padding:"12px 14px",marginBottom:8,border:`1px solid ${estCol}22`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
              <div>
                <div style={{fontWeight:700,fontSize:13,color:"#1D3A57"}}>{inc.nombre}</div>
                <div style={{fontSize:11,color:"#7a9ab0",marginTop:2}}>{inc.tipoInc||inc.tipo} · {inc.fecha} · {inc.empresa||"---"}</div>
                <div style={{fontSize:11,color:"#8aaacc",marginTop:2}}>{inc.puesto||"---"} · Jefe: {inc.jefe||"---"}</div>
                {inc.hEntrada&&<div style={{fontSize:11,color:"#8aaacc"}}>↑{inc.hEntrada} ↓{inc.hSalida||"---"} · {inc.totalHoras||"---"} · {inc.diferencia||"---"}</div>}
                {inc.observaciones&&<div style={{fontSize:11,color:"#8aabbc",marginTop:2,fontStyle:"italic"}}>{inc.observaciones}</div>}
                <div style={{marginTop:6,display:"flex",gap:6,alignItems:"center"}}>
                  <span style={{fontSize:10,background:estCol+"20",color:estCol,borderRadius:4,padding:"2px 8px",fontWeight:700}}>{est}</span>
                  {inc.revisadaPor&&<span style={{fontSize:10,color:"#8aabbc"}}>por {inc.revisadaPor}</span>}
                </div>
              </div>
              {(isRH||isAdmin)&&inc.aprobada===undefined&&(
                <div style={{display:"flex",flexDirection:"column",gap:6,flexShrink:0}}>
                  <button onClick={()=>aprobar(inc.id,true)} style={{background:"#00e5a020",border:"1px solid #00e5a0",borderRadius:7,padding:"6px 10px",color:"#00b4c8",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>✅ Aprobar</button>
                  <button onClick={()=>aprobar(inc.id,false)} style={{background:"#ff6b6b20",border:"1px solid #ff6b6b",borderRadius:7,padding:"6px 10px",color:"#ff6b6b",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>❌ Cancelar</button>
                </div>
              )}
              {(isRH||isAdmin)&&inc.aprobada!==undefined&&(
                <button onClick={()=>aprobar(inc.id,undefined)} style={{background:"#e8eef6",border:"none",borderRadius:7,padding:"5px 8px",color:"#7a9ab0",cursor:"pointer",fontSize:11,fontFamily:"inherit"}}>↩ Reset</button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ─── MÓDULO 1: SOLICITUD DE TIEMPO LIBRE ─────────────────────────
async function generarPDFPermiso(sol, session){
  const JsPDF=await loadJsPDF(); const doc=new JsPDF({orientation:"portrait",unit:"mm",format:"letter"}); const W=215.9,mg=14;
  doc.setFont("helvetica","bold"); doc.setFontSize(11); doc.setTextColor(0,80,160);
  doc.text("SIMA BV",mg,14); doc.text("www.simabv.mx",W-mg,14,{align:"right"});
  doc.setFontSize(7); doc.setTextColor(80,80,80); doc.text("Servicios Integrales de Mantenimiento",mg,19);
  doc.setDrawColor(0,80,160); doc.setLineWidth(0.4); doc.line(mg,21,W-mg,21);
  doc.setFont("helvetica","bold"); doc.setFontSize(12); doc.setTextColor(255,255,255);
  doc.setFillColor(13,71,161); doc.rect(mg,24,W-mg*2,8,"F");
  doc.text("SOLICITUD DE PERMISO LABORAL",W/2,29.5,{align:"center"});
  doc.setTextColor(30,30,30);
  doc.autoTable({startY:34,head:[["Nombre del solicitante","Área","Cargo","Fecha de elaboración"]],body:[[session.name,session.dept,session.puesto||"",sol.fechaHora]],styles:{fontSize:8,cellPadding:2},headStyles:{fillColor:[50,50,50],textColor:255,fontStyle:"bold",fontSize:7},margin:{left:mg,right:mg},theme:"grid"});
  let y=doc.lastAutoTable.finalY+4;
  const tipo=sol.tipo;
  doc.setFillColor(13,71,161); doc.rect(mg,y,W-mg*2,7,"F"); doc.setFont("helvetica","bold"); doc.setFontSize(9); doc.setTextColor(255,255,255);
  doc.text("TIPO DE SOLICITUD: "+tipo.toUpperCase(),W/2,y+4.5,{align:"center"}); y+=10;
  doc.autoTable({startY:y,head:[["Campo","Valor"]],body:[
    ["Fecha de inicio",sol.fechaInicio||""],
    ["Fecha de finalización",sol.fechaFin||""],
    ["Fecha de retorno",sol.fechaRetorno||""],
    ["Motivo / Justificación",sol.motivo||""],
    tipo==="Vacaciones"?["Días solicitados",sol.diasSolicitados||""]:["",""],
  ].filter(r=>r[0]),styles:{fontSize:9,cellPadding:3},headStyles:{fillColor:[100,100,100],textColor:255},margin:{left:mg,right:mg},theme:"grid"});
  y=doc.lastAutoTable.finalY+6;
  doc.setFillColor(13,71,161); doc.rect(mg,y,W-mg*2,7,"F"); doc.setFont("helvetica","bold"); doc.setFontSize(9); doc.setTextColor(255,255,255);
  doc.text("AUTORIZACIONES",W/2,y+4.5,{align:"center"}); y+=10;
  doc.autoTable({startY:y,head:[["SOLICITANTE","JEFE INMEDIATO","RECURSOS HUMANOS"]],body:[[session.name,sol.jefe||"",sol.aprobadorRH||"Leonardo Moreno"]],styles:{fontSize:8,cellPadding:8},headStyles:{fillColor:[50,50,50],textColor:255,fontStyle:"bold"},margin:{left:mg,right:mg},theme:"grid"});
  y=doc.lastAutoTable.finalY+4;
  doc.setFontSize(7); doc.setTextColor(100,100,100);
  ["1. Para permisos por ausencia deben solicitarse con anticipación no menor a 3 días.","2. Para vacaciones deben solicitarse con anticipación de 15 días.","3. Home Office solo para personal administrativo y a consideración del jefe y RH.","4. Cualquier otra solicitud será revisada por su jefe inmediato y Recursos Humanos."].forEach((n,i)=>{doc.text(n,mg,y+i*4);});
  doc.save(`Permiso_${sol.tipo}_${session.name.replace(/ /g,"_")}.pdf`);
}


// ─── BASE DE VACACIONES (fecha de ingreso por usuario) ────────────
// ─── SALDO INICIAL DE VACACIONES (del Excel base de vacaciones) ─────────────
// Contiene los días PENDIENTES (restantes) ya calculados a la fecha de carga
const VAC_SALDO_INICIAL = {
  "sergio.alvarado":0,"rocio.avila":16,"jose.bautista":0,"juan.cano":19,
  "javier.ceron":0,"cesar.chavez":22,"jose.felipe":0,"maricarmen.fraile":2,
  "jose.gudino":8,"cristian.hernandez":5,"fernando.hernandez":0,"israel.juarez":3,
  "pedro.lopez":0,"cuauhtemoc.montes":1,"julio.ramirez":21,"ibeth.rodriguez":7,
  "angel.rodriguez":4,"israel.romero":8,"brayan.gomez":9,"luis.valdespino":0,
  "abel.vazquez":10,"ana.avila":0,"mariana.gutierrez":11,"fred.torres":9,
  "israel.hernandez":0,"leonardo.moreno":0
};
// Días YA USADOS según el corte del Excel (Correspondientes − Pendientes)
const VAC_USADOS_EXCEL = {
  "sergio.alvarado":0,"rocio.avila":0,"jose.bautista":0,"juan.cano":3,
  "javier.ceron":0,"cesar.chavez":0,"jose.felipe":0,"maricarmen.fraile":10,
  "jose.gudino":4,"cristian.hernandez":7,"fernando.hernandez":0,"israel.juarez":9,
  "pedro.lopez":24,"cuauhtemoc.montes":13,"julio.ramirez":3,"ibeth.rodriguez":5,
  "angel.rodriguez":8,"israel.romero":6,"brayan.gomez":3,"luis.valdespino":0,
  "abel.vazquez":6,"ana.avila":0,"mariana.gutierrez":1,"fred.torres":3,
  "israel.hernandez":0,"leonardo.moreno":0
};

// Calcula datos de antigüedad a partir del campo "ingreso" de GestionUsuarios
function calcVacaciones(ingStr, refDate){
  if(!ingStr) return {diasCorresponden:0, anios:0, ingreso:"Sin registro", proximoAniversario:"---", aniversarioInicio:null, primerAnioCompleto:false};
  const ing = new Date(ingStr + "T00:00:00");
  if(isNaN(ing)) return {diasCorresponden:0, anios:0, ingreso:"Sin registro", proximoAniversario:"---", aniversarioInicio:null, primerAnioCompleto:false};
  const hoy = refDate || new Date();
  const diffMs = hoy - ing;
  const anios = Math.floor(diffMs / (365.25 * 24 * 3600 * 1000));
  const primerAnioCompleto = anios >= 1;
  let diasCorresponden = 0;
  if(anios < 1) diasCorresponden = 0;
  else if(anios === 1) diasCorresponden = 12;
  else if(anios === 2) diasCorresponden = 14;
  else if(anios === 3) diasCorresponden = 16;
  else if(anios === 4) diasCorresponden = 18;
  else if(anios === 5) diasCorresponden = 20;
  else diasCorresponden = 22;
  const pad = n => String(n).padStart(2,"0");
  const anivActual = new Date(ing);
  anivActual.setFullYear(ing.getFullYear() + Math.max(1, anios));
  const aniversarioInicio = `${anivActual.getFullYear()-1}-${pad(anivActual.getMonth()+1)}-${pad(anivActual.getDate())}`;
  const prox = new Date(ing);
  prox.setFullYear(ing.getFullYear() + anios + 1);
  const proxStr = `${pad(prox.getDate())}/${pad(prox.getMonth()+1)}/${prox.getFullYear()}`;
  // Fecha primer aniversario
  const primer = new Date(ing); primer.setFullYear(ing.getFullYear()+1);
  const primerStr = `${pad(primer.getDate())}/${pad(primer.getMonth()+1)}/${primer.getFullYear()}`;
  const ingStr2 = `${pad(ing.getDate())}/${pad(ing.getMonth()+1)}/${ing.getFullYear()}`;
  // Etiqueta del período: "AAAA-AAAA" basada en el último aniversario y el siguiente
  const periodoStart = anivActual.getFullYear() - 1;
  const periodoEnd   = anivActual.getFullYear();
  const periodoLabel = `${periodoStart}-${periodoEnd}`;
  return {diasCorresponden, anios, ingreso:ingStr2, proximoAniversario:proxStr, aniversarioInicio, primerAnioCompleto, primerAniversario:primerStr, periodoLabel};
}

// Días tomados en el app (solicitudes Aprobadas o Pendientes de vacaciones normales o extraordinarias)
function calcDiasTomadosEnApp(solicitudes, userEmail, refDate){
  const hoy = refDate || new Date();
  hoy.setHours(0,0,0,0);
  return solicitudes
    .filter(s => {
      if(s.email !== userEmail) return false;
      if(s.tipo !== "Vacaciones" && s.tipo !== "Vacaciones Extraordinarias") return false;
      if(s.estado === "Cancelada" || s.estado === "Rechazada") return false;
      // Solo cuenta si la fecha de FIN ya pasó (días efectivamente tomados)
      if(!s.fechaFin) return false;
      const fin = new Date(s.fechaFin + "T00:00:00");
      return fin < hoy;
    })
    .reduce((sum, s) => sum + (parseInt(s.diasSolicitados)||0), 0);
}

function SolicitudTiempoLibre({session,now,showToast,solicitudes,setSolicitudes,users}){
  const tipos=["Vacaciones","Permiso con goce de sueldo","Sin goce de sueldo","Tiempo Compensado","Home Office"];
  const [tipo,setTipo]=useState(tipos[0]);
  const [form,setForm]=useState({fechaInicio:"",fechaFin:"",fechaRetorno:"",motivo:"",diasSolicitados:"",jefe:"",motivoGoce:"",motivoSinGoce:"",diaTrabajo:"",diaCompensado:"",actividades:""});
  const [saving,setSaving]=useState(false);
  const setF=(k,v)=>setForm(p=>({...p,[k]:v}));

  const sessionUser = users ? users.find(u=>u.user===session?.user) : null;
  const vacIngreso = sessionUser?.ingreso || "";
  const vacInfo = calcVacaciones(vacIngreso, now);
  const saldoInicial = VAC_SALDO_INICIAL[session?.user] ?? null;
  const diasTomadosEnApp = calcDiasTomadosEnApp(solicitudes, session?.user, now);
  // Saldo = saldo inicial del Excel − lo tomado en el app
  const saldoDisponible = saldoInicial !== null ? Math.max(-99, saldoInicial - diasTomadosEnApp) : Math.max(0, vacInfo.diasCorresponden - diasTomadosEnApp);
  const diasRestantes = saldoDisponible;
  const usadosExcel = VAC_USADOS_EXCEL[session?.user] ?? 0;
  const diasTomados = usadosExcel + diasTomadosEnApp;
  const esExtraordinaria = !vacInfo.primerAnioCompleto;

  // Auto-calc días solicitados when fechaInicio and fechaFin are set
  const diasCalc = (() => {
    if(!form.fechaInicio || !form.fechaFin) return "";
    const d1 = new Date(form.fechaInicio+"T00:00:00"), d2 = new Date(form.fechaFin+"T00:00:00");
    if(d2 < d1) return "";
    let days = 0;
    const cur = new Date(d1);
    while(cur <= d2){ const wd = cur.getDay(); if(wd!==0&&wd!==6) days++; cur.setDate(cur.getDate()+1); }
    return String(days);
  })();

  const handleEnviar=async()=>{
    if(!form.fechaInicio){showToast("Indica la fecha de inicio","err");return;}
    if(!form.jefe){showToast("Selecciona el jefe inmediato","err");return;}
    const diasPedidos = parseInt(diasCalc||"0")||0;
    if(tipo==="Vacaciones"){
      if(!vacInfo.primerAnioCompleto && saldoInicial===0){
        showToast("No tienes días disponibles. Solicitar vacaciones antes de cumplir 1 año requiere autorización especial.","err"); return;
      }
      if(diasPedidos > Math.abs(diasRestantes) + (diasRestantes < 0 ? 0 : diasRestantes) && diasRestantes <= 0 && !(!vacInfo.primerAnioCompleto)){
        showToast(`Sin días disponibles (${diasRestantes})`, "err"); return;
      }
    }
    setSaving(true);
    const tipoReal = (tipo==="Vacaciones" && esExtraordinaria) ? "Vacaciones Extraordinarias" : tipo;
    const sol={id:genId(),tipo:tipoReal,fechaHora:fmtISO(now),email:session.user,nombre:session.name,puesto:session.puesto,dept:session.dept,
      ...form,diasSolicitados:diasCalc||form.diasSolicitados,
      estado:"Pendiente",aprobadoCesar:undefined,aprobadoRH:undefined,comentarioCesar:"",
      vacDiasCorresponden:vacInfo.diasCorresponden,vacAnios:vacInfo.anios};
    setSolicitudes(p=>[sol,...p]);
    await generarPDFPermiso(sol,session);
    showToast("Solicitud enviada y PDF generado ✓");
    setSaving(false);
    setForm({fechaInicio:"",fechaFin:"",fechaRetorno:"",motivo:"",diasSolicitados:"",jefe:"",motivoGoce:"",motivoSinGoce:"",diaTrabajo:"",diaCompensado:"",actividades:""});
  };

  const solPropias=solicitudes.filter(s=>s.email===session.user);

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      <div style={S.card}>
        <h2 style={{...S.cardTitle,margin:0,marginBottom:4}}>🏖️ Solicitud de Tiempo Libre</h2>
        <div><label style={S.label}>Tipo de solicitud</label>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {tipos.map(t=><button key={t} onClick={()=>setTipo(t)} style={{background:tipo===t?"#00b4c8":"#22272f",border:`1px solid ${tipo===t?"#00b4c8":"#2e333d"}`,borderRadius:8,padding:"6px 12px",color:tipo===t?"#ffffff":"#aaa",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>{t}</button>)}
          </div>
        </div>

        {/* ── VACACIONES: info automática ── */}
        {tipo==="Vacaciones"&&(
          <div style={{background:"#f5f8fc",borderRadius:10,padding:"12px 14px",border:`1px solid ${esExtraordinaria?"#ffd16640":"#00e5a030"}`}}>
            {/* Encabezado con periodo */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
              <span style={{fontSize:11,color:"#8aaacc",fontWeight:700}}>📊 VACACIONES</span>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                {vacIngreso&&!esExtraordinaria&&<span style={{fontSize:11,color:"#a29bfe",fontWeight:700,background:"#a29bfe15",border:"1px solid #a29bfe30",borderRadius:4,padding:"2px 8px"}}>Periodo {vacInfo.periodoLabel}</span>}
                {esExtraordinaria&&<span style={{fontSize:10,background:"#ffd16620",color:"#1a3a6e",border:"1px solid #ffd16640",borderRadius:4,padding:"2px 8px",fontWeight:700}}>⚡ EXTRAORDINARIA</span>}
              </div>
            </div>
            {!vacIngreso
              ? <div style={{fontSize:12,color:"#1a3a6e",fontWeight:600}}>⚠️ Sin fecha de ingreso — solicita a RH que la configure en Gestión de Usuarios</div>
              : <>
                  {/* Solo 3 contadores */}
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                    <div style={{background:"#eef3f9",borderRadius:8,padding:"10px 8px",textAlign:"center"}}>
                      <div style={{fontSize:9,color:"#8aabbc",marginBottom:4,letterSpacing:"0.5px"}}>DÍAS DEL PERIODO</div>
                      <div style={{fontSize:26,color:"#00b4c8",fontWeight:900,lineHeight:1}}>{vacInfo.diasCorresponden}</div>
                      <div style={{fontSize:9,color:"#9ab0c0",marginTop:3}}>según ley</div>
                    </div>
                    <div style={{background:"#eef3f9",borderRadius:8,padding:"10px 8px",textAlign:"center"}}>
                      <div style={{fontSize:9,color:"#8aabbc",marginBottom:4,letterSpacing:"0.5px"}}>USADOS</div>
                      <div style={{fontSize:26,color:diasTomados>0?"#ff6b6b":"#444",fontWeight:900,lineHeight:1}}>{diasTomados}</div>
                      <div style={{fontSize:9,color:"#9ab0c0",marginTop:3}}>tomados</div>
                    </div>
                    <div style={{background:"#eef3f9",borderRadius:8,padding:"10px 8px",textAlign:"center",border:`1px solid ${diasRestantes>0?"#00e5a040":diasRestantes===0?"#55555540":"#ff6b6b40"}`}}>
                      <div style={{fontSize:9,color:"#8aabbc",marginBottom:4,letterSpacing:"0.5px"}}>DISPONIBLES</div>
                      <div style={{fontSize:26,color:diasRestantes>0?"#ffd166":diasRestantes===0?"#666":"#ff6b6b",fontWeight:900,lineHeight:1}}>{diasRestantes}</div>
                      <div style={{fontSize:9,color:"#9ab0c0",marginTop:3}}>restantes</div>
                    </div>
                  </div>
                  {esExtraordinaria&&(
                    <div style={{marginTop:8,background:"#ffd16610",borderRadius:8,padding:"8px 12px",border:"1px solid #ffd16630"}}>
                      <div style={{fontSize:11,color:"#1a3a6e",fontWeight:700,marginBottom:2}}>⚡ Solicitud Extraordinaria</div>
                      <div style={{fontSize:11,color:"#7a9ab0",lineHeight:1.4}}>Aún no completas tu primer año (ingreso: {vacInfo.ingreso}). Los días se descontarán de tus vacaciones futuras.</div>
                    </div>
                  )}
                  {!esExtraordinaria&&diasRestantes<=0&&<div style={{marginTop:8,fontSize:12,color:"#ff6b6b",fontWeight:600}}>⚠️ Sin días disponibles en este período</div>}
                </>
            }
          </div>
        )}

        {/* ── MOTIVO ESPECÍFICO POR TIPO ── */}
        {tipo==="Permiso con goce de sueldo"&&(
          <div><label style={S.label}>Motivo del permiso</label>
            <select style={S.select} value={form.motivoGoce} onChange={e=>setF("motivoGoce",e.target.value)}>
              <option value="">-- Seleccione --</option>
              {["Paternidad","Matrimonio","Defunción (Familiar Directo)"].map(m=><option key={m}>{m}</option>)}
            </select>
          </div>
        )}
        {tipo==="Sin goce de sueldo"&&(
          <div><label style={S.label}>Tipo de permiso sin goce</label>
            <select style={S.select} value={form.motivoSinGoce} onChange={e=>setF("motivoSinGoce",e.target.value)}>
              <option value="">-- Seleccione --</option>
              {["Cita Médica","Hacer Trámite","Otro"].map(m=><option key={m}>{m}</option>)}
            </select>
          </div>
        )}

        {/* ── FECHAS ── */}
        {tipo!=="Tiempo Compensado"&&(
          <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
            <div style={{flex:"1 1 120px"}}><label style={S.label}>Fecha de inicio</label><input style={S.input} type="date" value={form.fechaInicio} onChange={e=>setF("fechaInicio",e.target.value)}/></div>
            {tipo!=="Home Office"&&<div style={{flex:"1 1 120px"}}><label style={S.label}>Fecha de finalización</label><input style={S.input} type="date" value={form.fechaFin} onChange={e=>setF("fechaFin",e.target.value)}/></div>}
            {(tipo==="Vacaciones"||tipo==="Sin goce de sueldo")&&<div style={{flex:"1 1 120px"}}><label style={S.label}>Fecha de retorno</label><input style={S.input} type="date" value={form.fechaRetorno} onChange={e=>setF("fechaRetorno",e.target.value)}/></div>}
          </div>
        )}

        {/* ── TIEMPO COMPENSADO: día de trabajo + día compensado ── */}
        {tipo==="Tiempo Compensado"&&(
          <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
            <div style={{flex:"1 1 140px"}}><label style={S.label}>Día de trabajo</label><input style={S.input} type="date" value={form.diaTrabajo} onChange={e=>setF("diaTrabajo",e.target.value)}/></div>
            <div style={{flex:"1 1 140px"}}><label style={S.label}>Día compensado</label><input style={S.input} type="date" value={form.diaCompensado} onChange={e=>setF("diaCompensado",e.target.value)}/></div>
          </div>
        )}

        {/* ── DÍAS SOLICITADOS (vacaciones) ── */}
        {tipo==="Vacaciones"&&(()=>{
          const pedidos = parseInt(diasCalc||"0")||0;
          const excede = !esExtraordinaria && pedidos > 0 && pedidos > diasRestantes;
          const deuda = esExtraordinaria ? pedidos : 0;
          return(
            <>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                <div>
                  <label style={S.label}>Días hábiles solicitados (auto)</label>
                  <div style={{...S.input,background:"#eef3f9",color:excede?"#ff6b6b":esExtraordinaria&&pedidos>0?"#ffd166":"#00b4c8",fontWeight:800,fontSize:18,textAlign:"center",padding:"10px 8px",cursor:"default",border:excede?"1px solid #ff6b6b33":"1px solid #2e333d"}}>{diasCalc||"---"}</div>
                </div>
                <div>
                  <label style={S.label}>{esExtraordinaria?"Días que se descontarán":"Días disponibles"}</label>
                  <div style={{...S.input,background:"#eef3f9",color:esExtraordinaria?"#ffd166":diasRestantes>0?"#ffd166":"#ff6b6b",fontWeight:800,fontSize:18,textAlign:"center",padding:"10px 8px",cursor:"default"}}>{esExtraordinaria?deuda:diasRestantes}</div>
                </div>
              </div>
              {excede&&(
                <div style={{background:"#ff6b6b15",border:"1px solid #ff6b6b40",borderRadius:10,padding:"10px 14px",display:"flex",alignItems:"flex-start",gap:8}}>
                  <span style={{fontSize:16,flexShrink:0}}>⚠️</span>
                  <span style={{fontSize:12,color:"#ff6b6b",fontWeight:600,lineHeight:1.4}}>Los días solicitados ({pedidos}) exceden los disponibles ({diasRestantes}). Ajusta el rango de fechas.</span>
                </div>
              )}
              {esExtraordinaria&&pedidos>0&&(
                <div style={{background:"#ffd16610",border:"1px solid #ffd16630",borderRadius:10,padding:"10px 14px",display:"flex",alignItems:"flex-start",gap:8}}>
                  <span style={{fontSize:16,flexShrink:0}}>⚡</span>
                  <span style={{fontSize:12,color:"#1a3a6e",fontWeight:600,lineHeight:1.4}}>Se descontarán {pedidos} día(s) de tus vacaciones futuras al cumplir el primer año.</span>
                </div>
              )}
            </>
          );
        })()}

        {/* ── JEFE INMEDIATO ── */}
        <div><label style={S.label}>Jefe inmediato</label>
          <select style={S.select} value={form.jefe} onChange={e=>setF("jefe",e.target.value)}>
            {TEAM_LIDERES.map(l=><option key={l} value={l}>{l||"-- Seleccione --"}</option>)}
          </select>
        </div>

        {/* ── CAMPO DE TEXTO SOLO HOME OFFICE ── */}
        {tipo==="Home Office"&&(
          <div><label style={S.label}>Actividades a desarrollar</label>
            <textarea style={{...S.input,height:70,resize:"vertical"}} value={form.actividades} onChange={e=>setF("actividades",e.target.value)} placeholder="Describe las actividades a realizar en Home Office…"/>
          </div>
        )}

        <button onClick={handleEnviar} disabled={saving} style={{...S.checkBtn,background:"#1D3A57",color:"#fff",fontWeight:800,fontSize:15}}>
          {saving?"⏳ Enviando…":"📤 Enviar Solicitud"}
        </button>
      </div>


    </div>
  );
}

// ─── MÓDULO 2: APROBACIÓN DE SOLICITUDES ─────────────────────────
function AprobacionSolicitudes({session,showToast,solicitudes,setSolicitudes,users}){
  const isLider=session?.nivel<=2;
  const isRH=session?.puesto?.toLowerCase().includes("recursos humanos")||session?.nivel===1;
  const [comentario,setComentario]=useState({});
  const [showCom,setShowCom]=useState({});

  // Líder sees pending; RH sees only Líder-approved; Admin sees both
  let visible=solicitudes.filter(s=>s.email!==session.user);
  if(isLider&&!isRH) visible=visible.filter(s=>s.aprobadoCesar===undefined&&s.estado==="Pendiente");
  if(isRH&&!isLider) visible=visible.filter(s=>s.aprobadoCesar===true&&s.aprobadoRH===undefined);
  if(isLider&&isRH) visible=visible.filter(s=>(s.aprobadoCesar===undefined&&s.estado==="Pendiente")||(s.aprobadoCesar===true&&s.aprobadoRH===undefined));

  const accionLider=(id,aprobado)=>{
    if(!aprobado&&!comentario[id]?.trim()){showToast("Escribe un comentario de negativa","err");return;}
    setSolicitudes(p=>p.map(s=>s.id===id?{...s,aprobadoCesar:aprobado,comentarioCesar:aprobado?"":comentario[id]||"",estado:aprobado?"Pendiente RH":"Cancelada",revisadoPorCesar:session.name}:s));
    showToast(aprobado?"✅ Aprobado por Líder — pasa a RH":"❌ Solicitud rechazada por Líder");
    setShowCom(p=>({...p,[id]:false}));
  };
  const accionRH=(id,aprobado)=>{
    setSolicitudes(p=>p.map(s=>s.id===id?{...s,aprobadoRH:aprobado,estado:aprobado?"Aprobada":"Cancelada por RH",revisadoPorRH:session.name}:s));
    showToast(aprobado?"✅ Solicitud aprobada por RH":"❌ Solicitud cancelada por RH");
  };

  return(
    <div style={S.card}>
      <h2 style={{...S.cardTitle,margin:0,marginBottom:8}}>✅ Aprobación de Solicitudes</h2>
      <div style={{fontSize:11,color:"#8aabbc",marginBottom:8}}>{visible.length} solicitude(s) pendiente(s)</div>
      {visible.length===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"20px 0"}}>No hay solicitudes pendientes</p>}
      {visible.map(sol=>{
        const col=sol.estado==="Aprobada"?"#00b4c8":sol.estado==="Cancelada"?"#ff6b6b":"#ffd166";
        return(
          <div key={sol.id} style={{background:"#f0f6fb",borderRadius:10,padding:"12px 14px",marginBottom:10,border:`1px solid ${col}33`}}>
            <div style={{fontWeight:700,color:"#1D3A57",fontSize:13}}>{sol.nombre}</div>
            <div style={{fontSize:11,color:"#7a9ab0",marginTop:2}}>{sol.tipo} · {sol.fechaInicio} → {sol.fechaFin||"---"}</div>
            <div style={{fontSize:11,color:"#8aaacc"}}>Jefe: {sol.jefe||"---"} · Solicitado: {sol.fechaHora?.slice(0,10)}</div>
            {sol.motivo&&<div style={{fontSize:11,color:"#2a4a6a",marginTop:4,fontStyle:"italic"}}>{sol.motivo}</div>}
            <div style={{marginTop:8,display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
              {isLider&&sol.aprobadoCesar===undefined&&(<>
                <button onClick={()=>accionLider(sol.id,true)} style={{background:"#00e5a020",border:"1px solid #00e5a0",borderRadius:7,padding:"6px 10px",color:"#00b4c8",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>✅ Aprobar</button>
                <button onClick={()=>setShowCom(p=>({...p,[sol.id]:!p[sol.id]}))} style={{background:"#ff6b6b20",border:"1px solid #ff6b6b",borderRadius:7,padding:"6px 10px",color:"#ff6b6b",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>❌ Rechazar</button>
                {showCom[sol.id]&&(<div style={{width:"100%",marginTop:6,display:"flex",gap:6}}>
                  <input style={{...S.input,flex:1}} placeholder="Motivo de rechazo…" value={comentario[sol.id]||""} onChange={e=>setComentario(p=>({...p,[sol.id]:e.target.value}))}/>
                  <button onClick={()=>accionLider(sol.id,false)} style={{background:"#ff6b6b",border:"none",borderRadius:8,padding:"8px 12px",color:"#fff",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>Enviar</button>
                </div>)}
              </>)}
              {isRH&&sol.aprobadoCesar===true&&sol.aprobadoRH===undefined&&(<>
                <button onClick={()=>accionRH(sol.id,true)} style={{background:"#00e5a020",border:"1px solid #00e5a0",borderRadius:7,padding:"6px 10px",color:"#00b4c8",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>✅ Aprobar</button>
                <button onClick={()=>accionRH(sol.id,false)} style={{background:"#ff6b6b20",border:"1px solid #ff6b6b",borderRadius:7,padding:"6px 10px",color:"#ff6b6b",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>❌ Cancelar</button>
              </>)}
              <span style={{fontSize:10,background:col+"22",color:col,borderRadius:4,padding:"2px 8px",fontWeight:700}}>{sol.estado}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ─── MÓDULO 3: ACTIVIDADES DIARIAS Y VEHÍCULO ─────────────────────
const SUPERVISORES_ACT = ["","Juan Carlos Cano","César Chávez","Abel Vázquez","Pedro López","Cuauhtémoc Montes"];

function contarColaboradores(supervisor, cuadrilla){
  const supCount = supervisor ? 1 : 0;
  if(!cuadrilla.trim()) return supCount;
  // Split by comma or multiple spaces, filter empty
  const names = cuadrilla.split(/[,]+/).map(n=>n.trim()).filter(n=>n.length>0);
  return supCount + names.length;
}

// Mini viñetas editor — textarea con soporte de • al presionar Enter
function BulletTextarea({value, onChange, placeholder, style}){
  const ref = useRef(null);
  const handleKeyDown = (e) => {
    if(e.key === "Enter"){
      e.preventDefault();
      const el = ref.current;
      const start = el.selectionStart;
      const end = el.selectionEnd;
      const before = value.slice(0, start);
      const after = value.slice(end);
      // If current line has bullet, add bullet on new line; else just newline
      const currentLine = before.split("\n").pop();
      const bullet = currentLine.startsWith("• ") || currentLine === "•" ? "\n• " : "\n• ";
      const newVal = before + bullet + after;
      onChange(newVal);
      // Restore cursor after state update
      setTimeout(()=>{
        el.selectionStart = el.selectionEnd = start + bullet.length;
      }, 0);
    }
  };
  const handleChange = (e) => {
    let v = e.target.value;
    // Auto-add bullet on first character if empty
    if(v.length === 1 && value === "") v = "• " + v;
    onChange(v);
  };
  return (
    <textarea
      ref={ref}
      style={style}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
    />
  );
}

function ActividadesDiarias({session,now,showToast,actividades,setActividades,catalogos={}}){
  const emptyForm = ()=>({fecha:new Date().toISOString().slice(0,10),empresa:"",proyecto:"",supervisor:"",cuadrilla:"",vehiculo:"",po:"",actividadesText:"",observaciones:"",galeria:[]});
  const empresasAct = ["", ...(catalogos.empresas||EMPRESAS_INC_DEFAULT).slice().sort()];
  const _proyRaw = catalogos.proyectos||PROYECTOS_DEFAULT.map(n=>({nombre:n,activo:true}));
  const proyectosAct = ["", ..._proyRaw.filter(p=>(typeof p==="string"||p.activo)).map(p=>typeof p==="string"?p:p.nombre).sort()];
  const [form,setForm]=useState(emptyForm());
  const [saving,setSaving]=useState(false);
  const [histAbierto,setHistAbierto]=useState({});
  const [histFoto,setHistFoto]=useState(null);
  const setF=(k,v)=>setForm(p=>({...p,[k]:v}));

  const totalColab = contarColaboradores(form.supervisor, form.cuadrilla);

  const handleFoto=(e)=>{
    const files=Array.from(e.target.files);
    const restante = 50 - form.galeria.length;
    if(restante <= 0){showToast("Límite de 50 fotos alcanzado","err");return;}
    const slice = files.slice(0, restante);
    Promise.all(slice.map(f=>new Promise(res=>{
      const r=new FileReader();
      r.onload=ev=>res(ev.target.result);
      r.readAsDataURL(f);
    }))).then(imgs=>setF("galeria",[...form.galeria,...imgs]));
  };

  const handleGuardar=async()=>{
    if(!form.empresa){showToast("Selecciona empresa","err");return;}
    if(!form.actividadesText.trim()){showToast("Describe las actividades","err");return;}
    setSaving(true);
    const act={
      id:genId(),fechaHora:fmtISO(now),email:session.user,nombre:session.name,puesto:session.puesto,
      fecha:form.fecha,empresa:form.empresa,proyecto:form.proyecto,supervisor:form.supervisor,
      cuadrilla:form.cuadrilla,colaboradores:totalColab,vehiculo:form.vehiculo,po:form.po,
      actividadesText:form.actividadesText,observaciones:form.observaciones,galeria:form.galeria
    };
    setActividades(p=>[act,...p]);
    showToast("Actividad registrada ✓");
    setSaving(false);
    setForm(emptyForm());
  };

  // Historial: mostrar las del supervisor activo
  const propias=actividades.filter(a=>a.email===session.user);
  const toggleHist=(id)=>setHistAbierto(p=>({...p,[id]:!p[id]}));

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      <div style={S.card}>
        <h2 style={{...S.cardTitle,margin:0,marginBottom:4}}>🛠️ Actividades Diarias</h2>

        {/* Fila 1: Fecha · Empresa */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <div><label style={S.label}>Fecha</label><input style={S.input} type="date" value={form.fecha} onChange={e=>setF("fecha",e.target.value)}/></div>
          <div><label style={S.label}>Empresa</label>
            <select style={S.select} value={form.empresa} onChange={e=>setF("empresa",e.target.value)}>
              {empresasAct.map(e=><option key={e} value={e}>{e||"-- Seleccione --"}</option>)}
            </select>
          </div>
        </div>

        {/* Fila 2: Proyecto (libre) · PO */}
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:10}}>
          <div><label style={S.label}>Proyecto</label>
            <select style={S.select} value={form.proyecto} onChange={e=>setF("proyecto",e.target.value)}>
              {proyectosAct.map(p=><option key={p} value={p}>{p||"-- Seleccione --"}</option>)}
            </select>
          </div>
          <div><label style={S.label}>PO (opcional)</label>
            <input style={S.input} value={form.po} onChange={e=>setF("po",e.target.value)} placeholder="No. PO…"/>
          </div>
        </div>

        {/* Fila 3: Supervisor · Cuadrilla · Total (auto) — alineados */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr auto",gap:10,alignItems:"end"}}>
          <div>
            <label style={S.label}>Supervisor</label>
            <select style={S.select} value={form.supervisor} onChange={e=>setF("supervisor",e.target.value)}>
              {SUPERVISORES_ACT.map(s=><option key={s} value={s}>{s||"-- Seleccione --"}</option>)}
            </select>
          </div>
          <div>
            <label style={S.label}>Cuadrilla <span style={{color:"#8aabbc",fontWeight:400}}>(separar por coma)</span></label>
            <input style={S.input} value={form.cuadrilla} onChange={e=>setF("cuadrilla",e.target.value)} placeholder="Ej: Pedro, Juan, Luis…"/>
          </div>
          <div style={{minWidth:90}}>
            <label style={S.label}>Total personas</label>
            <div style={{...S.input,background:"#eef3f9",color:"#00b4c8",fontWeight:800,fontSize:18,textAlign:"center",padding:"10px 8px",cursor:"default"}}>
              {totalColab}
            </div>
          </div>
        </div>

        {/* Vehículo */}
        <div><label style={S.label}>Vehículo asignado</label>
          <select style={S.select} value={form.vehiculo} onChange={e=>setF("vehiculo",e.target.value)}>
            {VEHICULOS.map(v=><option key={v} value={v}>{v||"-- Sin vehículo --"}</option>)}
          </select>
        </div>

        {/* Actividades con viñetas */}
        <div>
          <label style={S.label}>Actividades realizadas <span style={{color:"#8aabbc",fontWeight:400,fontSize:11}}>(Enter = nueva viñeta)</span></label>
          <BulletTextarea
            value={form.actividadesText}
            onChange={v=>setF("actividadesText",v)}
            placeholder="• Describe la primera actividad…"
            style={{...S.input,height:110,resize:"vertical",fontFamily:"inherit",lineHeight:1.6}}
          />
        </div>

        {/* Galería */}
        <div>
          <label style={S.label}>Galería fotográfica
            <span style={{color:"#8aabbc",fontWeight:400,marginLeft:6}}>({form.galeria.length}/50)</span>
          </label>
          {form.galeria.length < 50 &&
            <label style={{display:"inline-flex",alignItems:"center",gap:6,background:"#f0f6fb",border:"1px dashed #2e333d",borderRadius:8,padding:"8px 14px",cursor:"pointer",fontSize:12,color:"#6a8aaa",marginBottom:6}}>
              📷 Agregar fotos
              <input type="file" accept="image/*" multiple onChange={handleFoto} style={{display:"none"}}/>
            </label>
          }
          {form.galeria.length>0&&(
            <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:6}}>
              {form.galeria.map((img,i)=>(
                <div key={i} style={{position:"relative"}}>
                  <img src={img} style={{width:64,height:64,objectFit:"cover",borderRadius:6,border:"1px solid #d8e8f4",cursor:"pointer"}}
                    onClick={()=>setHistFoto(img)} alt=""/>
                  <button onClick={()=>setF("galeria",form.galeria.filter((_,x)=>x!==i))}
                    style={{position:"absolute",top:-5,right:-5,background:"#ff6b6b",border:"none",borderRadius:"50%",width:18,height:18,fontSize:10,color:"#fff",cursor:"pointer",lineHeight:"18px",textAlign:"center",padding:0}}>✕</button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Observaciones */}
        <div><label style={S.label}>Observaciones</label>
          <textarea style={{...S.input,height:60,resize:"vertical"}} value={form.observaciones} onChange={e=>setF("observaciones",e.target.value)} placeholder="Observaciones adicionales…"/>
        </div>

        <button onClick={handleGuardar} disabled={saving} style={{...S.checkBtn,background:"linear-gradient(135deg,#a29bfe,#6c5ce7)",color:"#fff",fontWeight:800,fontSize:15}}>
          {saving?"⏳ Guardando…":"💾 Registrar Actividades"}
        </button>
      </div>

      {/* Visor de foto ampliada */}
      {histFoto&&(
        <div onClick={()=>setHistFoto(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.92)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <img src={histFoto} style={{maxWidth:"100%",maxHeight:"92vh",borderRadius:10,boxShadow:"0 8px 40px rgba(0,0,0,0.8)"}} alt=""/>
          <button onClick={()=>setHistFoto(null)} style={{position:"fixed",top:16,right:16,background:"#e8eef6",border:"none",color:"#fff",borderRadius:8,width:32,height:32,cursor:"pointer",fontSize:16}}>✕</button>
        </div>
      )}


    </div>
  );
}

// ════ MAIN APP ════════════════════════════════════════════════════
// ─── GESTIÓN DE CATÁLOGOS ────────────────────────────────────────────
function GestionCatalogos({catalogos, setCatalogos, showToast}){
  const [tab,setTab] = useState("empresas");
  const [nuevo,setNuevo] = useState("");

  // Empresas: array of strings. Proyectos: array of {nombre, activo}
  const empresas = (catalogos.empresas||[]);
  const proyectos = (catalogos.proyectos||[]).map(p=>typeof p==="string"?{nombre:p,activo:true}:p);

  const agregarEmpresa = () => {
    const val = nuevo.trim().toUpperCase();
    if(!val){showToast("Escribe un nombre","err");return;}
    if(empresas.map(x=>x.toUpperCase()).includes(val)){showToast("Ya existe","err");return;}
    setCatalogos(p=>({...p,empresas:[...empresas,val]}));
    setNuevo(""); showToast(`"${val}" agregado ✓`);
  };
  const eliminarEmpresa = (item) => {
    setCatalogos(p=>({...p,empresas:empresas.filter(x=>x!==item)}));
    showToast(`"${item}" eliminado`);
  };

  const agregarProyecto = () => {
    const val = nuevo.trim().toUpperCase();
    if(!val){showToast("Escribe un nombre","err");return;}
    if(proyectos.map(p=>p.nombre.toUpperCase()).includes(val)){showToast("Ya existe","err");return;}
    setCatalogos(p=>({...p,proyectos:[...proyectos,{nombre:val,activo:true}]}));
    setNuevo(""); showToast(`"${val}" agregado ✓`);
  };
  const toggleProyecto = (nombre) => {
    setCatalogos(p=>({...p,proyectos:proyectos.map(x=>x.nombre===nombre?{...x,activo:!x.activo}:x)}));
  };
  const eliminarProyecto = (nombre) => {
    setCatalogos(p=>({...p,proyectos:proyectos.filter(x=>x.nombre!==nombre)}));
    showToast(`"${nombre}" eliminado`);
  };

  const empOrdenadas = [...empresas].sort();
  const proyOrdenados = [...proyectos].sort((a,b)=>a.nombre.localeCompare(b.nombre));

  return(
    <div style={S.card}>
      <h2 style={{...S.cardTitle,margin:0,marginBottom:10}}>📂 Catálogos de Actividades</h2>
      <div style={{display:"flex",gap:6,marginBottom:12}}>
        {[["empresas","🏢 Empresas"],["proyectos","📁 Proyectos"]].map(([k,lbl])=>(
          <button key={k} onClick={()=>{setTab(k);setNuevo("");}} style={{background:tab===k?"#00b4c8":"#22272f",border:`1px solid ${tab===k?"#00b4c8":"#2e333d"}`,borderRadius:8,padding:"6px 16px",color:tab===k?"#ffffff":"#aaa",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>{lbl}</button>
        ))}
      </div>

      <div style={{display:"flex",gap:8,marginBottom:10}}>
        <input style={{...S.input,flex:1,margin:0}} placeholder={`Nuevo ${tab==="empresas"?"cliente / empresa":"proyecto"}…`} value={nuevo} onChange={e=>setNuevo(e.target.value)} onKeyDown={e=>e.key==="Enter"&&(tab==="empresas"?agregarEmpresa():agregarProyecto())}/>
        <button onClick={tab==="empresas"?agregarEmpresa:agregarProyecto} style={{background:"#1D3A57",border:"none",borderRadius:10,padding:"0 18px",color:"#ffffff",fontWeight:800,fontSize:14,cursor:"pointer",fontFamily:"inherit",flexShrink:0,height:42}}>+ Agregar</button>
      </div>

      {tab==="empresas"&&(
        <>
          <div style={{fontSize:11,color:"#8aabbc",marginBottom:6}}>{empOrdenadas.length} empresa(s)</div>
          <div style={{display:"flex",flexDirection:"column",gap:4,maxHeight:320,overflowY:"auto"}}>
            {empOrdenadas.map(item=>(
              <div key={item} style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#f0f6fb",borderRadius:8,padding:"9px 12px",border:"1px solid #d8e8f4"}}>
                <span style={{fontSize:13,color:"#2a4a6a"}}>{item}</span>
                <button onClick={()=>eliminarEmpresa(item)} style={{background:"none",border:"none",color:"#ff6b6b",cursor:"pointer",fontSize:18,padding:"0 2px",lineHeight:1}}>✕</button>
              </div>
            ))}
            {empOrdenadas.length===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"16px 0",fontSize:12}}>Sin empresas. Agrega la primera arriba.</p>}
          </div>
        </>
      )}

      {tab==="proyectos"&&(
        <>
          <div style={{display:"flex",gap:12,marginBottom:6,fontSize:11,color:"#8aabbc"}}>
            <span>✅ {proyOrdenados.filter(p=>p.activo).length} activo(s)</span>
            <span>🔒 {proyOrdenados.filter(p=>!p.activo).length} cerrado(s)</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:4,maxHeight:360,overflowY:"auto"}}>
            {proyOrdenados.map(p=>(
              <div key={p.nombre} style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#f0f6fb",borderRadius:8,padding:"9px 12px",border:`1px solid ${p.activo?"#2e333d":"#ffd16630"}`,opacity:p.activo?1:0.6}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:11}}>{p.activo?"✅":"🔒"}</span>
                  <span style={{fontSize:13,color:p.activo?"#ccc":"#888",textDecoration:p.activo?"none":"line-through"}}>{p.nombre}</span>
                </div>
                <div style={{display:"flex",gap:6,alignItems:"center"}}>
                  <button onClick={()=>toggleProyecto(p.nombre)} title={p.activo?"Cerrar proyecto":"Reactivar"} style={{background:p.activo?"#ffd16620":"#00e5a020",border:`1px solid ${p.activo?"#ffd16640":"#00e5a040"}`,borderRadius:6,padding:"3px 10px",color:p.activo?"#ffd166":"#00b4c8",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>{p.activo?"Cerrar":"Activar"}</button>
                  <button onClick={()=>eliminarProyecto(p.nombre)} style={{background:"none",border:"none",color:"#ff6b6b",cursor:"pointer",fontSize:18,padding:"0 2px",lineHeight:1}}>✕</button>
                </div>
              </div>
            ))}
            {proyOrdenados.length===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"16px 0",fontSize:12}}>Sin proyectos. Agrega el primero arriba.</p>}
          </div>
        </>
      )}
    </div>
  );
}

// ─── PERSISTENCIA localStorage ────────────────────────────────────
const lsKey = (user, k) => `simabv_${user}_${k}`;
const lsGet = (user, k, def) => { try { const v=localStorage.getItem(lsKey(user,k)); return v!=null?JSON.parse(v):def; } catch{ return def; } };
const lsSet = (user, k, v) => { try { localStorage.setItem(lsKey(user,k), JSON.stringify(v)); } catch(_){} };
const lsClear = (user) => { ["checkedIn","checkLog","incidents","reqCount","checkForm"].forEach(k=>localStorage.removeItem(lsKey(user,k))); };



// ─── PAGINADOR REUTILIZABLE ─────────────────────────────────────
function Paginator({page,totalPages,setPage}){
  if(totalPages<=1) return null;
  const pages=[];
  for(let i=1;i<=totalPages;i++){
    if(i===1||i===totalPages||Math.abs(i-page)<=2) pages.push(i);
    else if(pages[pages.length-1]!=="...") pages.push("...");
  }
  return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:4,marginTop:10,flexWrap:"wrap"}}>
      <button onClick={()=>setPage(Math.max(1,page-1))} disabled={page===1} style={{background:"#1D3A57",color:"#fff",border:"none",borderRadius:6,padding:"6px 10px",fontSize:12,fontWeight:700,cursor:page===1?"default":"pointer",opacity:page===1?0.4:1,fontFamily:"inherit"}}>← Anterior</button>
      {pages.map((p,i)=>p==="..."?<span key={"e"+i} style={{color:"#8aabbc",fontSize:12}}>…</span>:
        <button key={p} onClick={()=>setPage(p)} style={{background:p===page?"#1D3A57":"transparent",color:p===page?"#fff":"#1D3A57",border:p===page?"none":"1px solid #d0dcea",borderRadius:6,padding:"6px 10px",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit",minWidth:32}}>{p}</button>
      )}
      <button onClick={()=>setPage(Math.min(totalPages,page+1))} disabled={page===totalPages} style={{background:"#1D3A57",color:"#fff",border:"none",borderRadius:6,padding:"6px 10px",fontSize:12,fontWeight:700,cursor:page===totalPages?"default":"pointer",opacity:page===totalPages?0.4:1,fontFamily:"inherit"}}>Siguiente →</button>
    </div>
  );
}

// ─── Helper: vigencia de credencial ─────────────────────────────
function credVigenciaColor(fechaVenc){
  if(!fechaVenc) return {color:"#8aabbc",label:"---"};
  const hoy=new Date(); hoy.setHours(0,0,0,0);
  const venc=new Date(fechaVenc+"T00:00:00"); 
  const diffDays=Math.floor((venc-hoy)/(1000*60*60*24));
  if(diffDays<0) return {color:"#ff0000",label:"Vencida"};
  if(diffDays<=15) return {color:"#ff0000",label:"Por vencer"};
  if(diffDays<=45) return {color:"#ffc107",label:"Próxima"};
  return {color:"#00b894",label:"Vigente"};
}


// ─── ADMIN PANEL: secciones colapsables con paginación ──────────
function AdminPanel({session,showToast,solicitudes,setSolicitudes,allIncidents,setAllIncidents,allUsers}){
  const [openSec,setOpenSec]=useState({aprobaciones:true,asistencia:false,incpersonal:false});
  const toggle=(k)=>setOpenSec(p=>({...p,[k]:!p[k]}));

  const secHead=(key,icon,title,count)=>(
    <button onClick={()=>toggle(key)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",width:"100%",background:"none",border:"none",cursor:"pointer",padding:"14px 0 8px",borderBottom:"1px solid #e2eaf4",fontFamily:"inherit"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <span style={{fontSize:18}}>{icon}</span>
        <span style={{fontSize:15,fontWeight:700,color:"#1D3A57"}}>{title}</span>
        {count!==undefined&&<span style={{fontSize:11,background:"#eef4fb",color:"#7a9ab0",borderRadius:10,padding:"2px 8px",fontWeight:600}}>{count}</span>}
      </div>
      <span style={{fontSize:18,color:"#8aabbc",transition:"transform 0.2s",transform:openSec[key]?"rotate(180deg)":"rotate(0)"}}>{String.fromCharCode(9660)}</span>
    </button>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      <div style={S.card}>
        {secHead("aprobaciones","✅","Aprobación de Solicitudes")}
        {openSec.aprobaciones&&<div style={{marginTop:10}}><AprobacionSolicitudes session={session} showToast={showToast} solicitudes={solicitudes} setSolicitudes={setSolicitudes}/></div>}
      </div>
      {session?.nivel<=2&&(<>
        <div style={S.card}>
          {secHead("asistencia","📊","Panel de Asistencia")}
          {openSec.asistencia&&<div style={{marginTop:10}}><PanelAsistencia allUsers={allUsers}/></div>}
        </div>
        <div style={S.card}>
          {secHead("incpersonal","👔","Incidencias del Personal")}
          {openSec.incpersonal&&<div style={{marginTop:10}}><IncPersonal allIncidents={allIncidents} setAllIncidents={setAllIncidents} session={session} showToast={showToast} allUsers={allUsers}/></div>}
        </div>
      </>)}
    </div>
  );
}

// ─── MI INFO: Tab unificado con secciones colapsables ─────────────
function MiInfoPanel({checkLog,incidents,allIncidents,session,requisiciones,showToast,canReq,solicitudes,actividades,users}){
  const [openSec,setOpenSec]=useState({asistencia:true,incidencias:false,requisiciones:false,solicitudes:false,actividades:false,credenciales:false});
  const misCreds=((users||[]).find(u=>u.user===session?.user)||{}).credenciales||[];
  const toggle=(k)=>setOpenSec(p=>({...p,[k]:!p[k]}));
  const PG=10;
  const [pg,setPg]=useState({a:1,i:1,r:1,s:1,t:1});
  const setPgK=(k,v)=>setPg(p=>({...p,[k]:v}));

  const solPropias=(solicitudes||[]).filter(s=>s.email===session.user);
  const actPropias=(actividades||[]).filter(a=>a.email===session.user);

  const secHead=(key,icon,title,count)=>(
    <button onClick={()=>toggle(key)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",width:"100%",background:"none",border:"none",cursor:"pointer",padding:"14px 0 8px",borderBottom:"1px solid #e2eaf4",fontFamily:"inherit"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <span style={{fontSize:18}}>{icon}</span>
        <span style={{fontSize:15,fontWeight:700,color:"#1D3A57"}}>{title}</span>
        {count!==undefined&&<span style={{fontSize:11,background:"#eef4fb",color:"#7a9ab0",borderRadius:10,padding:"2px 8px",fontWeight:600}}>{count}</span>}
      </div>
      <span style={{fontSize:18,color:"#8aabbc",transition:"transform 0.2s",transform:openSec[key]?"rotate(180deg)":"rotate(0)"}}>{String.fromCharCode(9660)}</span>
    </button>
  );

  const paginate=(arr,pgKey)=>{const p=pg[pgKey];const tot=Math.ceil(arr.length/PG);return{items:arr.slice((p-1)*PG,p*PG),page:p,totalPages:tot,setPage:v=>setPgK(pgKey,v)};};

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {/* Mi Asistencia */}
      <div style={S.card}>
        {secHead("asistencia","📅","Mi Asistencia",checkLog.length)}
        {openSec.asistencia&&(<div style={{marginTop:10}}>
          <HistorialSemana checkLog={checkLog}/>
          {checkLog.length===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"12px 0"}}>Sin registros aún</p>}
        </div>)}
      </div>

      {/* Mis Incidencias */}
      <div style={S.card}>
        {secHead("incidencias","🗒","Mis Incidencias",incidents.length)}
        {openSec.incidencias&&(<div style={{marginTop:10}}>
          <MisIncidencias incidents={incidents} allIncidents={allIncidents} session={session}/>
        </div>)}
      </div>

      {/* Mis Requisiciones */}
      {canReq&&(<div style={S.card}>
        {secHead("requisiciones","📁","Mis Requisiciones",requisiciones.length)}
        {openSec.requisiciones&&(<div style={{marginTop:10}}>
          <MisRequisiciones requisiciones={requisiciones} showToast={showToast}/>
        </div>)}
      </div>)}

      {/* Mis Solicitudes */}
      <div style={S.card}>
        {secHead("solicitudes","📋","Mis Solicitudes",solPropias.length)}
        {openSec.solicitudes&&(<div style={{marginTop:10}}>
          {solPropias.length===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"12px 0"}}>Sin solicitudes aún</p>}
          {(()=>{const{items,page,totalPages,setPage}=paginate(solPropias,"s");return(<>
            {items.map(sol=>{const col=sol.estado==="Aprobada"?"#00b4c8":sol.estado==="Cancelada"||sol.estado==="Cancelada por RH"?"#ff6b6b":"#ffd166";return(
              <div key={sol.id} style={{background:"#f0f6fb",borderRadius:10,padding:"12px 14px",marginBottom:8,border:"1px solid "+col+"33"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{fontWeight:700,color:"#1D3A57",fontSize:13}}>{sol.tipo}</div>
                    <div style={{fontSize:11,color:"#7a9ab0",marginTop:2}}>{sol.fechaInicio||"---"} → {sol.fechaFin||sol.fechaInicio||"---"} · Jefe: {sol.jefe||"---"}</div>
                    {sol.revisadoPorCesar&&<div style={{fontSize:10,color:sol.aprobadoCesar?"#00b4c8":"#ff6b6b",marginTop:2}}>Líder: {sol.revisadoPorCesar} — {sol.aprobadoCesar?"✅":"❌"}</div>}
                    {sol.revisadoPorRH&&<div style={{fontSize:10,color:sol.aprobadoRH?"#00b4c8":"#ff6b6b",marginTop:2}}>RH: {sol.revisadoPorRH} — {sol.aprobadoRH?"✅":"❌"}</div>}
                  </div>
                  <span style={{fontSize:10,background:col+"22",color:col,borderRadius:4,padding:"2px 8px",fontWeight:700}}>{sol.estado}</span>
                </div>
              </div>
            );})}
            <Paginator page={page} totalPages={totalPages} setPage={setPage}/>
          </>);})()}
        </div>)}
      </div>

      {/* Credenciales Vigentes */}
      <div style={S.card}>
        {secHead("credenciales","📜","Credenciales Vigentes",misCreds.length)}
        {openSec.credenciales&&(<div style={{marginTop:10}}>
          {misCreds.length===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"12px 0"}}>Sin credenciales registradas</p>}
          {misCreds.map((c,i)=>{
            const vig=credVigenciaColor(c.fechaVenc);
            return(
              <div key={i} style={{background:"#f5f8fc",borderRadius:10,padding:"10px 12px",marginBottom:8,border:"1px solid #e2eaf4"}}>
                <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                  <div style={{flex:"1 1 130px"}}><label style={{fontSize:10,color:"#7a9ab0"}}>Empresa</label><div style={{fontSize:12,fontWeight:600,color:"#1D3A57"}}>{c.empresa||"---"}</div></div>
                  <div style={{flex:"1 1 110px"}}><label style={{fontSize:10,color:"#7a9ab0"}}>Vencimiento</label><div style={{fontSize:12,fontWeight:600,color:"#1D3A57"}}>{c.fechaVenc||"---"}</div></div>
                  <div style={{flex:"0 0 90px",textAlign:"center"}}><label style={{fontSize:10,color:"#7a9ab0"}}>Vigente</label><div style={{fontSize:11,fontWeight:800,color:vig.color,background:vig.color+"18",borderRadius:6,padding:"3px 8px"}}>{vig.label}</div></div>
                </div>
              </div>
            );
          })}
        </div>)}
      </div>

      {/* Historial Actividades */}
      <div style={S.card}>
        {secHead("actividades","🛠️","Historial de Actividades",actPropias.length)}
        {openSec.actividades&&(<div style={{marginTop:10}}>
          {actPropias.length===0&&<p style={{color:"#8aabbc",textAlign:"center",margin:"12px 0"}}>Sin actividades aún</p>}
          {(()=>{const{items,page,totalPages,setPage}=paginate(actPropias,"t");return(<>
            {items.map(a=>(
              <div key={a.id} style={{background:"#f0f6fb",borderRadius:10,padding:"12px 14px",marginBottom:8,border:"1px solid #e2eaf4"}}>
                <div style={{fontWeight:700,color:"#1D3A57",fontSize:13}}>{a.fecha} · {a.empresa||"---"}</div>
                <div style={{fontSize:11,color:"#7a9ab0",marginTop:2}}>🧑 {a.supervisor||"---"} · 👥 {a.totalColab||"---"} personas · 🚗 {a.vehiculo||"---"}</div>
              </div>
            ))}
            <Paginator page={page} totalPages={totalPages} setPage={setPage}/>
          </>);})()}
        </div>)}
      </div>
    </div>
  );
}


export default function App(){
  const [users,setUsers]     = useState(INITIAL_USERS);
  const [session,setSession] = useState(null);
  const [view,setView]       = useState("checado");
  const [now,setNow]         = useState(new Date());
  const [geo,setGeo]         = useState(null);
  const [geoError,setGeoError]=useState(null);
  const [checkLog,setCheckLog]=useState([]);
  const [incidents,setIncidents]=useState([]);
  const [allIncidents,setAllIncidents]=useState(()=>{try{return JSON.parse(localStorage.getItem("simabv__global_allIncidents")||"[]");}catch{return[];}});
  const [requisiciones,setRequisiciones]=useState([]);
  const [reqCount,setReqCount]=useState(0);
  const [solicitudes,setSolicitudes]=useState(()=>{try{return JSON.parse(localStorage.getItem("simabv__global_solicitudes")||"[]");}catch{return[];}});
  const [actividades,setActividades]=useState(()=>{try{return JSON.parse(localStorage.getItem("simabv__global_actividades")||"[]");}catch{return[];}});
  const [catalogos,setCatalogos]=useState(()=>{
    try{ const v=localStorage.getItem("simabv__global_catalogos"); if(v) return JSON.parse(v); }catch{}
    return {empresas:[...EMPRESAS_INC_DEFAULT], proyectos:PROYECTOS_DEFAULT.map(n=>({nombre:n,activo:true}))};
  });
  const [checkedIn,setCheckedIn]=useState(false);
  const [pulse,setPulse]     = useState(false);
  const [loginUser,setLoginUser]=useState("");
  const [loginPass,setLoginPass]=useState("");
  const [loginError,setLoginError]=useState("");
  const [toast,setToast]     = useState(null);
  const [checkForm,setCheckForm]=useState({proyecto:"",teamLider:"",actividad:""});

  // Persistir allIncidents globalmente
  useEffect(()=>{try{localStorage.setItem("simabv__global_allIncidents",JSON.stringify(allIncidents));}catch(_){}},[allIncidents]);
  useEffect(()=>{try{localStorage.setItem("simabv__global_solicitudes",JSON.stringify(solicitudes));}catch(_){}},[solicitudes]);
  useEffect(()=>{try{localStorage.setItem("simabv__global_actividades",JSON.stringify(actividades));}catch(_){}},[actividades]);
  useEffect(()=>{try{localStorage.setItem("simabv__global_catalogos",JSON.stringify(catalogos));}catch(_){}},[catalogos]);

  useEffect(()=>{const t=setInterval(()=>setNow(new Date()),1000);return()=>clearInterval(t);},[]);
  useEffect(()=>{
    if(!session) return;
    if(!navigator.geolocation){ setGeoError("Tu dispositivo no soporta GPS"); return; }
    navigator.geolocation.getCurrentPosition(
      p=>setGeo({lat:p.coords.latitude.toFixed(6),lng:p.coords.longitude.toFixed(6),acc:Math.round(p.coords.accuracy)}),
      e=>{
        if(e.code===1) setGeoError("Permiso de ubicación denegado — actívalo en ajustes del navegador");
        else if(e.code===2) setGeoError("No se pudo obtener señal GPS — intenta en exterior");
        else if(e.code===3) setGeoError("Tiempo de espera agotado — reintentando…");
        else setGeoError("GPS no disponible");
      },
      {enableHighAccuracy:true, timeout:10000, maximumAge:0}
    );
  },[session]);

  // ── Cargar estado persistido al hacer login ──
  const cargarEstado = (username) => {
    const log  = lsGet(username,"checkLog",[]);
    const inc  = lsGet(username,"incidents",[]);
    const cin  = lsGet(username,"checkedIn",false);
    const cnt  = lsGet(username,"reqCount",0);
    const cf   = lsGet(username,"checkForm",{proyecto:"",teamLider:"",actividad:""});
    const reqs = lsGet(username,"requisiciones",[]);
    setCheckLog(log);
    setIncidents(inc);
    setCheckedIn(cin);
    setReqCount(cnt);
    setCheckForm(cf);
    setRequisiciones(reqs);
    GLOBAL_LOG=[...log,...inc,...GLOBAL_LOG.filter(r=>r.email!==username)];
  };

  const showToast=(msg,type="ok")=>{setToast({msg,type});setTimeout(()=>setToast(null),3500);};

  const handleLogin=()=>{
    const u=users.find(x=>x.user===loginUser&&x.pass===loginPass);
    if(!u){setLoginError("Usuario o contraseña incorrectos");return;}
    if(!u.activo){setLoginError("Usuario inactivo. Contacta al administrador.");return;}
    setSession({...u,nivel:getNivel(u.user)});
    cargarEstado(u.user);
    setLoginError("");
    setView("checado");
  };

  const handleCheck=async()=>{
    if(!checkedIn){
      if(!checkForm.proyecto){showToast("Selecciona un proyecto","err");return;}
      if(!checkForm.teamLider){showToast("Selecciona un team líder","err");return;}
      if(!checkForm.actividad.trim()){showToast("Describe la actividad","err");return;}
    }
    const tipo=checkedIn?"Salida":"Entrada"; const ts=fmtISO(now); const ip=await getIP();
    const proyecto  = checkForm.proyecto  || checkLog.find(r=>r.checkTipo==="Entrada")?.proyecto  || "";
    const teamLider = checkForm.teamLider || checkLog.find(r=>r.checkTipo==="Entrada")?.teamLider || "";
    const actividad = checkForm.actividad || checkLog.find(r=>r.checkTipo==="Entrada")?.actividad || "";
    const entry={id:genId(),tipo:"checado",checkTipo:tipo,ts,hora:fmt(now),fecha:fmtD(now),nombre:session.name,dept:session.dept,puesto:session.puesto,email:session.user,proyecto,teamLider,actividad,lat:geo?.lat??"---",lng:geo?.lng??"---",acc:geo?.acc??"---",ip};
    const nuevoLog=[entry,...checkLog];
    const nuevoCheckedIn=!checkedIn;
    GLOBAL_LOG=[entry,...GLOBAL_LOG];
    setCheckLog(nuevoLog);
    setCheckedIn(nuevoCheckedIn);
    // Persistir en localStorage
    lsSet(session.user,"checkLog", nuevoLog.slice(0,500));
    lsSet(session.user,"checkedIn", nuevoCheckedIn);
    if(tipo==="Salida") { setCheckForm({proyecto:"",teamLider:"",actividad:""}); lsSet(session.user,"checkForm",{proyecto:"",teamLider:"",actividad:""}); }
    setPulse(true); setTimeout(()=>setPulse(false),600);
    sendToSheet({tipo:"checado",fila:[ts,session.user,session.name,session.dept,proyecto,teamLider,actividad,tipo,geo?.lat??"",geo?.lng??"",geo?.acc??"",ip]});
    showToast(`${tipo} registrada ✓`);
  };

  const handleIncident=()=>{}; // legacy - replaced by FormIncidencias

  // ── Nav según nivel ──
  const navItems = () => {
    const canReq=["coordinador","gerente","auxiliar","ceo","analista","supervisor"].some(r=>session?.puesto?.toLowerCase().includes(r));
    const isLider=session?.nivel<=2;
    const isRH=session?.puesto?.toLowerCase().includes("recursos humanos")||session?.nivel===1;
    const base=[["checado","⏱","Checado"],["incidencias","📋","Incidencia"]];
    if(canReq) base.push(["requisicion","📄","Requisición"]);
    base.push(["miinfo","📂","Mi Info"]);
    base.push(["tiempolibre","🏖️","T. Libre"]);
    base.push(["actividades","🛠️","Actividad."]);
    if(isLider||isRH||session?.nivel<=2) base.push(["adminpanel","📊","Panel"]);
    if(session?.nivel===1) base.push(["usuarios","👥","Usuarios"]);
    return base;
  };

  // ── LOGIN ──
  if(!session) return(
    <div style={S.loginRoot}><style>{CSS}</style>
      <div style={S.loginCard}>
        <div style={{textAlign:"center",marginBottom:8}}><img src={LOGO_PRINCIPAL} alt="Grupo BV" style={{height:50,objectFit:"contain"}}/></div>
        <input style={S.loginInput} type="text" placeholder="Usuario" value={loginUser} onChange={e=>setLoginUser(e.target.value.toLowerCase())} onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
        <input style={S.loginInput} type="password" placeholder="Contraseña" value={loginPass} onChange={e=>setLoginPass(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
        {loginError&&<div style={S.loginErr}>{loginError}</div>}
        <button onClick={handleLogin} style={S.loginBtn}>Ingresar →</button>
      </div>
    </div>
  );

  return(
    <div style={S.root}><style>{CSS}</style>
      {toast&&<div style={{...S.toast,background:toast.type==="ok"?"#00b4c8":"#e05050"}}>{toast.msg}</div>}

      <header style={S.header}>
        <img src={LOGO_ISOTIPO} alt="Grupo BV" style={{height:32,objectFit:"contain"}}/>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{textAlign:"right"}}>
            <div style={{fontSize:11,fontWeight:700,color:nivelColor(session.nivel)}}>{nivelLabel(session.nivel)}</div>
            <div style={{fontSize:10,color:"#8aabbc"}}>{session.user}</div>
          </div>
          {session.foto?<img src={session.foto} alt="" style={{...S.avatar,objectFit:"cover"}}/>:<div style={{...S.avatar,background:`linear-gradient(135deg,${nivelColor(session.nivel)},${nivelColor(session.nivel)}99)`}}>{session.name[0]}{session.name.split(" ")[1]?.[0]||""}</div>}
        </div>
      </header>

      <nav style={{...S.nav,overflowX:"auto"}}>
        {navItems().map(([v,ic,lb])=>(
          <button key={v} onClick={()=>setView(v)} style={{...S.navBtn,...(view===v?S.navActive:{}),minWidth:52}}>
            <span>{ic}</span><span style={S.navLabel}>{lb}</span>
          </button>
        ))}
      </nav>

      <main style={S.main}>

        {view==="checado"&&(
          <div style={S.card}>
            <div style={S.clockWrap}><div style={S.clockTime}>{fmt(now)}</div><div style={S.clockDate}>{fmtD(now)}</div></div>
            <div style={S.userBadge}>
              {session.foto?<img src={session.foto} alt="" style={{...S.userAv,objectFit:"cover"}}/>:<div style={{...S.userAv,background:`linear-gradient(135deg,${nivelColor(session.nivel)},${nivelColor(session.nivel)}88)`}}>{session.name[0]}{session.name.split(" ")[1]?.[0]||""}</div>}
              <div>
                <div style={S.userName}>{session.name}</div>
                <div style={S.userEmail}>{session.dept}{session.puesto?` · ${session.puesto}`:""}</div>
              </div>
            </div>
            {checkLog.length>0&&(
              <div style={{background: checkLog[0].checkTipo==="Entrada"?"#00e5a015":"#ff6b6b15", border:`1px solid ${checkLog[0].checkTipo==="Entrada"?"#00e5a030":"#ff6b6b30"}`, borderRadius:10, padding:"10px 14px", fontSize:12}}>
                <span style={{color:scColor(checkLog[0].checkTipo),fontWeight:700}}>Último registro: {checkLog[0].checkTipo}</span>
                <span style={{color:"#8aaacc",marginLeft:8}}>{checkLog[0].ts}</span>
                {checkLog[0].proyecto&&<div style={{color:"#7a9ab0",marginTop:3}}>📁 {checkLog[0].proyecto} · 🔧 {checkLog[0].actividad}</div>}
              </div>
            )}
            {geo?<div style={S.geoBox}><span style={S.geoDot}/><span style={S.geoText}>📍 {geo.lat}, {geo.lng} · ±{geo.acc}m</span></div>:<div style={{...S.geoBox,opacity:0.5}}>📍 {geoError||"Obteniendo ubicación…"}</div>}

            {!checkedIn ? (
              <>
                <div><label style={S.label}>Proyecto</label>
                  <select style={S.select} value={checkForm.proyecto} onChange={e=>setCheckForm({...checkForm,proyecto:e.target.value})}>
                    <option value="">-- Seleccione proyecto --</option>
                    {(()=>{const _pr=catalogos?.proyectos||PROYECTOS_DEFAULT.map(n=>({nombre:n,activo:true}));return _pr.filter(p=>typeof p==="string"||p.activo).map(p=>typeof p==="string"?p:p.nombre).sort().map(n=><option key={n} value={n}>{n}</option>);})()}
                  </select>
                </div>
                <div><label style={S.label}>Team líder</label>
                  <select style={S.select} value={checkForm.teamLider} onChange={e=>setCheckForm({...checkForm,teamLider:e.target.value})}>
                    <option value="">-- Seleccione líder --</option>{TEAM_LIDERES.filter(Boolean).map(l=><option key={l}>{l}</option>)}
                  </select>
                </div>
                <div><label style={S.label}>Actividad que realizas</label>
                  <input style={S.input} type="text" placeholder="Ej: Mantenimiento preventivo compresor" value={checkForm.actividad} onChange={e=>setCheckForm({...checkForm,actividad:e.target.value})}/>
                </div>
              </>
            ) : (
              <div style={{background:"#f0f6fb",borderRadius:12,padding:"14px 16px",display:"flex",flexDirection:"column",gap:8}}>
                <div style={{fontSize:11,color:"#8aaacc",fontWeight:700,textTransform:"uppercase",letterSpacing:0.5}}>Registro de entrada activo</div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}><span style={{fontSize:14}}>📁</span><div><div style={{fontSize:11,color:"#7a9ab0"}}>Proyecto</div><div style={{fontSize:13,color:"#1a2a3a",fontWeight:600}}>{checkForm.proyecto||checkLog[0]?.proyecto||"---"}</div></div></div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}><span style={{fontSize:14}}>👔</span><div><div style={{fontSize:11,color:"#7a9ab0"}}>Team líder</div><div style={{fontSize:13,color:"#1a2a3a",fontWeight:600}}>{checkForm.teamLider||checkLog[0]?.teamLider||"---"}</div></div></div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}><span style={{fontSize:14}}>🔧</span><div><div style={{fontSize:11,color:"#7a9ab0"}}>Actividad</div><div style={{fontSize:13,color:"#1a2a3a",fontWeight:600}}>{checkForm.actividad||checkLog[0]?.actividad||"---"}</div></div></div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}><span style={{fontSize:14}}>⏱</span><div><div style={{fontSize:11,color:"#7a9ab0"}}>Hora de entrada</div><div style={{fontSize:13,color:"#00b4c8",fontWeight:700}}>{tsHora(checkLog[0]?.ts)||"---"}</div></div></div>
              </div>
            )}

            <button onClick={handleCheck} className={pulse?"pulse":""} style={{...S.checkBtn,background:checkedIn?"#cc3344":"#1D3A57"}}>
              {checkedIn?"⏹ REGISTRAR SALIDA":"▶ REGISTRAR ENTRADA"}
            </button>

          </div>
        )}

{/* miasistencia moved to miinfo */}

        {view==="incidencias"&&(
          <FormIncidencias
            session={session}
            now={now}
            showToast={showToast}
            onEnviadas={(batch)=>{
              const nuevo=[...batch,...incidents].slice(0,500);
              setIncidents(nuevo);
              lsSet(session.user,"incidents",nuevo);
              setAllIncidents(prev=>[...batch,...prev]);
              GLOBAL_LOG=[...batch,...GLOBAL_LOG];
            }}
          />
        )}

{/* misincidencias moved to miinfo */}

        {view==="requisicion"&&<FormRequisicion session={session} now={now} showToast={showToast} catalogos={catalogos} onSaved={(req)=>{
          const nuevo=[req,...requisiciones];
          setRequisiciones(nuevo);
          lsSet(session.user,"requisiciones",nuevo);
          setReqCount(c=>c+1);
        }}/>}

{/* misrequisiciones moved to miinfo */}

        {view==="miinfo"&&(
          <MiInfoPanel
            checkLog={checkLog}
            incidents={incidents}
            allIncidents={allIncidents}
            session={session}
            requisiciones={requisiciones}
            showToast={showToast}
            canReq={["coordinador","gerente","auxiliar","ceo","analista","supervisor"].some(r=>session?.puesto?.toLowerCase().includes(r))}
            solicitudes={solicitudes}
            actividades={actividades}
            users={users}
          />
        )}

        {view==="tiempolibre"&&(
          <SolicitudTiempoLibre session={session} now={now} showToast={showToast} solicitudes={solicitudes} setSolicitudes={setSolicitudes} users={users}/>
        )}

        {view==="actividades"&&(
          <ActividadesDiarias session={session} now={now} showToast={showToast} actividades={actividades} setActividades={setActividades} catalogos={catalogos}/>
        )}

        {view==="adminpanel"&&(session?.nivel<=2||session?.puesto?.toLowerCase().includes("recursos humanos"))&&(
          <AdminPanel
            session={session}
            showToast={showToast}
            solicitudes={solicitudes}
            setSolicitudes={setSolicitudes}
            allIncidents={allIncidents}
            setAllIncidents={(upd)=>{setAllIncidents(typeof upd==="function"?upd(allIncidents):upd);}}
            allUsers={users}
          />
        )}
        {view==="usuarios"&&session?.nivel===1&&(
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <GestionUsuarios users={users} setUsers={setUsers} showToast={showToast} catalogos={catalogos}/>
              <GestionCatalogos catalogos={catalogos} setCatalogos={setCatalogos} showToast={showToast}/>
            </div>
          )}

      </main>

      <footer style={S.footer}>
        <button onClick={()=>{setSession(null);setCheckedIn(false);setCheckLog([]);setIncidents([]);setReqCount(0);setRequisiciones([]);setView("checado");}} style={S.logoutBtn}>SALIDA</button>
      </footer>
    </div>
  );
}

const S={
  root:{minHeight:"100vh",background:"#f0f4f8",color:"#1a2a3a",fontFamily:"'DM Sans','Segoe UI',sans-serif",display:"flex",flexDirection:"column",maxWidth:520,margin:"0 auto"},
  header:{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px 10px",borderBottom:"2px solid #00b4c820",background:"#ffffff",boxShadow:"0 2px 12px rgba(26,58,110,0.08)"},
  logo:{fontSize:24,fontWeight:800,letterSpacing:-1,color:"#1a3a6e"},headerSub:{fontSize:11,color:"#8aabbc",marginTop:1},
  avatar:{width:38,height:38,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:13,color:"#ffffff",overflow:"hidden"},
  nav:{display:"flex",background:"#ffffff",borderBottom:"2px solid #00b4c820"},
  navBtn:{flex:1,background:"none",border:"none",color:"#8aaacc",padding:"10px 4px 8px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:3,fontSize:16,transition:"color 0.2s",whiteSpace:"nowrap"},
  navActive:{color:"#00b4c8",borderBottom:"2.5px solid #00b4c8"},
  navLabel:{fontSize:8,fontWeight:600,letterSpacing:0.4},
  main:{flex:1,padding:"16px 14px"},
  card:{background:"#ffffff",borderRadius:16,padding:"22px 18px",display:"flex",flexDirection:"column",gap:13,boxShadow:"0 2px 12px rgba(26,58,110,0.06)",border:"1px solid #e2eaf4"},
  cardTitle:{margin:0,fontSize:17,fontWeight:700,color:"#1a3a6e"},
  clockWrap:{textAlign:"center",padding:"4px 0"},
  clockTime:{fontSize:48,fontWeight:800,letterSpacing:-2,color:"#1a3a6e",lineHeight:1},
  clockDate:{fontSize:12,color:"#8aabbc",marginTop:5,textTransform:"capitalize"},
  userBadge:{display:"flex",alignItems:"center",gap:12,background:"#eef4fb",borderRadius:12,padding:"11px 14px",border:"1px solid #d8eaf8"},
  userAv:{width:40,height:40,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:14,color:"#ffffff",flexShrink:0,overflow:"hidden"},
  userName:{fontWeight:700,fontSize:14,color:"#1a2a3a"},userEmail:{fontSize:11,color:"#7a9ab0",marginTop:2},
  geoBox:{display:"flex",alignItems:"center",gap:8,background:"#eef4fb",borderRadius:10,padding:"9px 13px",border:"1px solid #d0e4f4"},
  geoDot:{width:8,height:8,borderRadius:"50%",background:"#00b4c8",flexShrink:0,boxShadow:"0 0 6px #00b4c880"},
  geoText:{fontSize:12,color:"#6a8aaa"},
  label:{fontSize:12,color:"#7a9ab0",fontWeight:600,letterSpacing:0.4,marginBottom:4,display:"block"},
  input:{background:"#ffffff",border:"1px solid #d0dcea",borderRadius:10,padding:"11px 13px",color:"#000000",fontSize:14,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"},
  select:{background:"#ffffff",border:"1px solid #d0dcea",borderRadius:10,padding:"11px 13px",color:"#000000",fontSize:14,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit",appearance:"none"},
  checkBtn:{padding:"17px 0",border:"none",borderRadius:14,color:"#ffffff",fontSize:16,fontWeight:800,cursor:"pointer",letterSpacing:1,background:"#1D3A57"},
  submitBtn:{background:"#1D3A57",border:"none",borderRadius:12,padding:"14px 0",color:"#ffffff",fontSize:15,fontWeight:700,cursor:"pointer"},
  histItem:{background:"#f0f6fb",borderRadius:10,padding:"11px 13px",position:"relative"},
  histTime:{position:"absolute",right:13,top:11,fontSize:11,color:"#8aaacc"},
  histSub:{fontSize:11,color:"#7a9ab0",marginTop:3},
  footer:{padding:"12px 16px 20px",borderTop:"1px solid #ddeaf4"},
  logoutBtn:{width:"100%",background:"#ff6b6b",border:"none",borderRadius:14,color:"#ffffff",padding:"14px 0",cursor:"pointer",fontSize:15,fontWeight:800,fontFamily:"inherit",letterSpacing:0.5},
  toast:{position:"fixed",top:16,left:"50%",transform:"translateX(-50%)",zIndex:1001,borderRadius:10,padding:"12px 22px",fontSize:13,fontWeight:700,color:"#ffffff",maxWidth:340,textAlign:"center",boxShadow:"0 4px 20px rgba(0,0,0,0.5)",animation:"fadeIn 0.3s ease"},
  loginRoot:{minHeight:"100vh",background:"linear-gradient(160deg,#0d1117 0%,#111a14 100%)",display:"flex",alignItems:"center",justifyContent:"center",padding:20},
  loginCard:{background:"#f5f8fc",borderRadius:20,padding:"40px 28px 32px",width:"100%",maxWidth:360,display:"flex",flexDirection:"column",gap:14,boxShadow:"0 8px 40px rgba(0,229,160,0.08)"},
  loginLogo:{fontSize:36,fontWeight:900,letterSpacing:-2,textAlign:"center",color:"#fff"},
  loginSub:{textAlign:"center",fontWeight:700,fontSize:16,color:"#2a4a6a",marginTop:-8},
  loginWa:{textAlign:"center",fontSize:11,color:"#8aaacc",marginBottom:8},
  loginInput:{background:"#ffffff",border:"1px solid #d0dcea",borderRadius:12,padding:"13px 15px",color:"#000000",fontSize:15,outline:"none",fontFamily:"inherit"},
  loginErr:{color:"#ff6b6b",fontSize:13,textAlign:"center"},
  loginBtn:{background:"#1D3A57",border:"none",borderRadius:12,padding:"15px 0",color:"#ffffff",fontSize:16,fontWeight:800,cursor:"pointer"},
  loginHint:{textAlign:"center",fontSize:11,color:"#8aabbc",margin:0},
};
const CSS=`
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700;800;900&display=swap');
  *{box-sizing:border-box;} body{margin:0;background:#111418;}
  @keyframes fadeIn{from{opacity:0;transform:translateX(-50%) translateY(-8px);}to{opacity:1;transform:translateX(-50%) translateY(0);}}
  @keyframes pulse{0%,100%{transform:scale(1);}50%{transform:scale(0.96);}}
  .pulse{animation:pulse 0.3s ease;} button:active{transform:scale(0.97);}
  input::placeholder,textarea::placeholder{color:#999;} select option{background:#ffffff;color:#000000;}
  ::-webkit-scrollbar{width:4px;} ::-webkit-scrollbar-track{background:#111;} ::-webkit-scrollbar-thumb{background:#333;border-radius:2px;}
  input[type=date]::-webkit-calendar-picker-indicator{filter:none;}
`;
